function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("4VIPJ", function(module, exports) {
    $parcel$export(module.exports, "JiraLossAversionExperiment", ()=>(parcelRequire("fHLcQ")).JiraLossAversionExperiment);
    var $fHLcQ;
});
parcelRegister("fHLcQ", function(module, exports) {
    $parcel$export(module.exports, "JiraLossAversionExperiment", ()=>$a3944ec24f6cee3d$export$2df1ad55126ecabc);
    var $51gAi;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $2vSU6;
    var $39xOx;
    var $4R6GH;
    var $koeKL;
    var $644lr;
    var $jCiEZ;
    var $9SAh4;
    const $a3944ec24f6cee3d$export$1cec38cf54975982 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { projectType: projectType } = (0, (0, parcelRequire("644lr")).useProjectType)();
        const shouldFetch = projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) && (0, (0, parcelRequire("4R6GH")).fg)('jira_loss_aversion_standard_gql_has_billing');
        const data = (0, $8Uumt.useLazyLoadQuery)((0, (0, parcelRequire("51gAi")).default), {
            cloudId: cloudId,
            productKey: 'jira-software.ondemand',
            shouldFetch: shouldFetch
        });
        const hasBilling = Boolean(data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable);
        (0, (0, parcelRequire("jCiEZ")).useJiraLossAversionAAExperiment)({
            isExperimentEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_loss_aversion_standard_gate_aa'),
            extraAnalytics: {},
            hasBilling: hasBilling
        });
        const { renderTreatment: renderTreatment } = (0, (0, parcelRequire("jCiEZ")).useJiraLossAversionABExperiment)({
            isExperimentEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_loss_aversion_standard_gate_ab'),
            extraAnalytics: {},
            hasBilling: hasBilling
        });
        if (renderTreatment) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9SAh4")).JiraLossAversionModal), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
    const $a3944ec24f6cee3d$export$2df1ad55126ecabc = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "jiraLossAversionExperiment",
            packageName: "jiraLossAversion",
            teamName: "luna-growth",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a3944ec24f6cee3d$export$1cec38cf54975982, null));
});
parcelRegister("51gAi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62371073c79837c3$export$2e2bcd8739ae039);
    const $62371073c79837c3$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "productKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldFetch"
            }
        ], v1 = [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ], v2 = [
            {
                "kind": "Variable",
                "name": "hamsProductKey",
                "variableName": "productKey"
            }
        ], v3 = [
            {
                "kind": "Literal",
                "name": "where",
                "value": {
                    "AND": [
                        {
                            "inTrialOrPreDunning": true
                        }
                    ]
                }
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "invoiceable"
        }, v5 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = [
            v6
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "uiJiraLossAversionHasPaymentQuery",
                "selections": [
                    {
                        "condition": "shouldFetch",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "TenantContext",
                                "kind": "LinkedField",
                                "name": "tenantContexts",
                                "plural": true,
                                "selections": [
                                    {
                                        "args": v2,
                                        "kind": "LinkedField",
                                        "name": "entitlementInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": v3,
                                                "kind": "LinkedField",
                                                "name": "entitlement",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "subscription",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "accountDetails",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "invoiceGroup",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v4,
                                                                                "action": "THROW",
                                                                                "path": "tenantContexts.entitlementInfo.entitlement.subscription.accountDetails.invoiceGroup.invoiceable"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "uiJiraLossAversionHasPaymentQuery",
                "selections": [
                    {
                        "condition": "shouldFetch",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "TenantContext",
                                "kind": "LinkedField",
                                "name": "tenantContexts",
                                "plural": true,
                                "selections": [
                                    {
                                        "args": v2,
                                        "kind": "LinkedField",
                                        "name": "entitlementInfo",
                                        "plural": false,
                                        "selections": [
                                            v5,
                                            {
                                                "args": v3,
                                                "kind": "LinkedField",
                                                "name": "entitlement",
                                                "plural": false,
                                                "selections": [
                                                    v5,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "subscription",
                                                        "plural": false,
                                                        "selections": [
                                                            v5,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "accountDetails",
                                                                "plural": false,
                                                                "selections": [
                                                                    v5,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "invoiceGroup",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v5,
                                                                            v4,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v7,
                                                                                "type": "CcpInvoiceGroup"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v7,
                                                                "type": "CcpSubscription"
                                                            }
                                                        ]
                                                    },
                                                    v6
                                                ],
                                                "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "9b57f8d2f1162538766ba5b4202a4233cda83c185a033522d32ef13094dbd9a9",
                "metadata": {},
                "name": "uiJiraLossAversionHasPaymentQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $62371073c79837c3$var$node.hash = "5d7f62e1285b435957547389de0d5f42";
    var $62371073c79837c3$export$2e2bcd8739ae039 = $62371073c79837c3$var$node;
});
parcelRegister("644lr", function(module, exports) {
    $parcel$export(module.exports, "useProjectType", ()=>$b51ed8b7a70961aa$export$6de29d851c914935);
    var $2vSU6;
    var $lpwtK;
    function $b51ed8b7a70961aa$export$6de29d851c914935() {
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectType = (0, (0, parcelRequire("2vSU6")).toProjectType)(project?.type);
        return {
            projectType: projectType
        };
    }
});
parcelRegister("jCiEZ", function(module, exports) {
    $parcel$export(module.exports, "useJiraLossAversionABExperiment", ()=>$94212574134fcb69$export$793c69f8a4d1e05);
    $parcel$export(module.exports, "useJiraLossAversionAAExperiment", ()=>$94212574134fcb69$export$2aef6eaacb8e2488);
    var $5uXOq = parcelRequire("5uXOq");
    var $9o6tH;
    var $jTugD;
    var $lQj7F;
    var $e0tHE;
    var $d2jVW;
    var $5p0uL;
    const $94212574134fcb69$var$useExperiment = ({ isExperimentEnabled: isExperimentEnabled, extraAnalytics: extraAnalytics, experimentName: experimentName, hasBilling: hasBilling })=>{
        const { isEligible: isEligible, isUrgent: isUrgent } = (0, (0, parcelRequire("9o6tH")).useExperimentEligibility)(experimentName, hasBilling);
        const { trialDaysLeft: trialDaysLeft } = (0, (0, parcelRequire("d2jVW")).useTrialDetails)();
        const { cohort: cohort, isEnrolled: isEnrolled, isTreatment: isTreatment } = (0, (0, parcelRequire("lQj7F")).useExperimentEnrollment)({
            experimentName: experimentName,
            skip: !isExperimentEnabled
        });
        const shouldTryShowExperiment = isExperimentEnabled && isEnrolled && isEligible;
        const { canShowExperiment: canShowExperiment } = (0, (0, parcelRequire("jTugD")).useCanShowExperiment)({
            skip: !shouldTryShowExperiment
        });
        const { fireExposureEvents: fireExposureEvents } = (0, (0, parcelRequire("e0tHE")).useFireExposureEvents)({
            skip: !canShowExperiment,
            experimentName: experimentName,
            extraAnalytics: {
                ...extraAnalytics,
                isUrgent: isUrgent,
                trialDaysLeft: trialDaysLeft
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            fireExposureEvents();
        }, [
            fireExposureEvents
        ]);
        if (!canShowExperiment) return {
            cohort: cohort,
            renderTreatment: false
        };
        (0, (0, parcelRequire("5p0uL")).setHasSeenModal)(experimentName, isUrgent);
        return {
            cohort: cohort,
            renderTreatment: isTreatment
        };
    };
    const $94212574134fcb69$export$793c69f8a4d1e05 = ({ isExperimentEnabled: isExperimentEnabled, extraAnalytics: extraAnalytics, hasBilling: hasBilling })=>$94212574134fcb69$var$useExperiment({
            isExperimentEnabled: isExperimentEnabled,
            extraAnalytics: extraAnalytics,
            experimentName: (0, $c173c7124ea4b2f6$export$855e843fe464d553),
            hasBilling: hasBilling
        });
    const $94212574134fcb69$export$2aef6eaacb8e2488 = ({ isExperimentEnabled: isExperimentEnabled, extraAnalytics: extraAnalytics, hasBilling: hasBilling })=>$94212574134fcb69$var$useExperiment({
            isExperimentEnabled: isExperimentEnabled,
            extraAnalytics: extraAnalytics,
            experimentName: (0, $c173c7124ea4b2f6$export$998e8261e98c7d7d),
            hasBilling: hasBilling
        });
});
const $c173c7124ea4b2f6$export$998e8261e98c7d7d = 'jira_loss_aversion_standard_aa';
const $c173c7124ea4b2f6$export$855e843fe464d553 = 'jira_loss_aversion_standard_ab';
parcelRegister("9o6tH", function(module, exports) {
    $parcel$export(module.exports, "useExperimentEligibility", ()=>$b67b1ef4d6cb3db4$export$42c0a6ccc8ff1bba);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $4R6GH;
    var $ldyPw;
    var $k5cv1;
    var $lQj7F;
    var $644lr;
    var $d2jVW;
    const $b67b1ef4d6cb3db4$var$isDevtestCohort = (cohort)=>cohort === 'devtesting' || cohort === 'devtesting_urgent';
    function $b67b1ef4d6cb3db4$export$42c0a6ccc8ff1bba(experimentName, hasBilling) {
        const { projectType: projectType } = (0, (0, parcelRequire("644lr")).useProjectType)();
        const { jswEdition: jswEdition, trialDaysLeft: trialDaysLeft, isInTrial: isInTrial, billingSourceSystem: billingSourceSystem } = (0, (0, parcelRequire("d2jVW")).useTrialDetails)();
        const { cohort: cohort } = (0, (0, parcelRequire("lQj7F")).useExperimentEnrollment)({
            experimentName: experimentName,
            skip: false
        });
        const isInDevtestCohort = $b67b1ef4d6cb3db4$var$isDevtestCohort(cohort);
        const isUrgent = isInDevtestCohort ? cohort === 'devtesting_urgent' : isInTrial && !!trialDaysLeft && trialDaysLeft <= 4;
        const hasSeenModal = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("k5cv1")).getHasSeenModal)(experimentName, isUrgent).hasSeenModal, [
            experimentName,
            isUrgent
        ]);
        const isEligible = projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) && jswEdition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION) && ((0, (0, parcelRequire("4R6GH")).fg)('jira_loss_aversion_standard_hams') || billingSourceSystem === 'CCP') && (!isInDevtestCohort ? isInTrial && !!trialDaysLeft && trialDaysLeft <= 8 : true) && !hasSeenModal && !hasBilling;
        return {
            isEligible: isEligible,
            isUrgent: isUrgent
        };
    }
});
parcelRegister("k5cv1", function(module, exports) {
    $parcel$export(module.exports, "getHasSeenModal", ()=>$7a8e117eef82a236$export$9b92cc6b9a20fe8e);
    var $eEPUd;
    function $7a8e117eef82a236$export$9b92cc6b9a20fe8e(expermientName, isUrgent) {
        const isAA = expermientName === (0, $c173c7124ea4b2f6$export$998e8261e98c7d7d);
        if (isUrgent) return {
            hasSeenModal: isAA ? (0, (0, parcelRequire("eEPUd")).getHasSeenUrgentModalAA)() : (0, (0, parcelRequire("eEPUd")).getHasSeenUrgentModalAB)()
        };
        return {
            hasSeenModal: isAA ? (0, (0, parcelRequire("eEPUd")).getHasSeenFirstModalAA)() : (0, (0, parcelRequire("eEPUd")).getHasSeenFirstModalAB)()
        };
    }
});
parcelRegister("eEPUd", function(module, exports) {
    $parcel$export(module.exports, "setHasSeenFirstModalAA", ()=>$2f81d9adb5b2ee43$export$f975a8547e308d3c);
    $parcel$export(module.exports, "getHasSeenFirstModalAA", ()=>$2f81d9adb5b2ee43$export$942862af653abbd);
    $parcel$export(module.exports, "setHasSeenUrgentModalAA", ()=>$2f81d9adb5b2ee43$export$d1618d387d45e1bf);
    $parcel$export(module.exports, "getHasSeenUrgentModalAA", ()=>$2f81d9adb5b2ee43$export$c029ab5532439a30);
    $parcel$export(module.exports, "setHasSeenFirstModalAB", ()=>$2f81d9adb5b2ee43$export$bce05b2cafc179e7);
    $parcel$export(module.exports, "getHasSeenFirstModalAB", ()=>$2f81d9adb5b2ee43$export$b37380d16b5e55e2);
    $parcel$export(module.exports, "setHasSeenUrgentModalAB", ()=>$2f81d9adb5b2ee43$export$e90779b576d8ea9);
    $parcel$export(module.exports, "getHasSeenUrgentModalAB", ()=>$2f81d9adb5b2ee43$export$50208fb710d06b8b);
    var $bSSG7;
    const $2f81d9adb5b2ee43$var$localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira-loss-aversion-standard');
    const $2f81d9adb5b2ee43$var$FIRST_MODAL_SEEN_AA = 'jla-first-modal-seen-aa';
    const $2f81d9adb5b2ee43$var$URGENT_MODAL_SEEN_AA = 'jla-urgent-modal-seen-aa';
    const $2f81d9adb5b2ee43$var$FIRST_MODAL_SEEN_AB = 'jla-first-modal-seen-ab';
    const $2f81d9adb5b2ee43$var$URGENT_MODAL_SEEN_AB = 'jla-urgent-modal-seen-ab';
    const $2f81d9adb5b2ee43$export$f975a8547e308d3c = ()=>{
        $2f81d9adb5b2ee43$var$localStorage.set($2f81d9adb5b2ee43$var$FIRST_MODAL_SEEN_AA, true);
    };
    const $2f81d9adb5b2ee43$export$942862af653abbd = ()=>$2f81d9adb5b2ee43$var$localStorage.get($2f81d9adb5b2ee43$var$FIRST_MODAL_SEEN_AA) || false;
    const $2f81d9adb5b2ee43$export$d1618d387d45e1bf = ()=>{
        $2f81d9adb5b2ee43$var$localStorage.set($2f81d9adb5b2ee43$var$URGENT_MODAL_SEEN_AA, true);
    };
    const $2f81d9adb5b2ee43$export$c029ab5532439a30 = ()=>$2f81d9adb5b2ee43$var$localStorage.get($2f81d9adb5b2ee43$var$URGENT_MODAL_SEEN_AA) || false;
    const $2f81d9adb5b2ee43$export$bce05b2cafc179e7 = ()=>{
        $2f81d9adb5b2ee43$var$localStorage.set($2f81d9adb5b2ee43$var$FIRST_MODAL_SEEN_AB, true);
    };
    const $2f81d9adb5b2ee43$export$b37380d16b5e55e2 = ()=>$2f81d9adb5b2ee43$var$localStorage.get($2f81d9adb5b2ee43$var$FIRST_MODAL_SEEN_AB) || false;
    const $2f81d9adb5b2ee43$export$e90779b576d8ea9 = ()=>{
        $2f81d9adb5b2ee43$var$localStorage.set($2f81d9adb5b2ee43$var$URGENT_MODAL_SEEN_AB, true);
    };
    const $2f81d9adb5b2ee43$export$50208fb710d06b8b = ()=>$2f81d9adb5b2ee43$var$localStorage.get($2f81d9adb5b2ee43$var$URGENT_MODAL_SEEN_AB) || false;
});
parcelRegister("lQj7F", function(module, exports) {
    $parcel$export(module.exports, "useExperimentEnrollment", ()=>$6c920d9c5c39f003$export$feb34becfec7693);
    var $6s1PB;
    function $6c920d9c5c39f003$var$getCohortValue(experimentName) {
        if (experimentName === (0, $c173c7124ea4b2f6$export$998e8261e98c7d7d)) {
            const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_loss_aversion_standard_aa');
            return expConfig.get('cohort', 'not-enrolled');
        }
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_loss_aversion_standard_ab');
        return expConfig.get('cohort', 'not-enrolled');
    }
    function $6c920d9c5c39f003$export$feb34becfec7693({ experimentName: experimentName, skip: skip }) {
        if (skip) return {
            cohort: 'not-enrolled',
            isEnrolled: false,
            isTreatment: false
        };
        const cohort = $6c920d9c5c39f003$var$getCohortValue(experimentName);
        const isTreatment = [
            'test',
            'devtesting',
            'devtesting_urgent'
        ].includes(cohort);
        const isEnrolled = cohort !== 'not-enrolled';
        return {
            cohort: cohort,
            isEnrolled: isEnrolled,
            isTreatment: isTreatment
        };
    }
});
parcelRegister("d2jVW", function(module, exports) {
    $parcel$export(module.exports, "useTrialDetails", ()=>$56cbbe02a148f8ee$export$be2f13183561cb);
    var $1laI5;
    var $9OXo1;
    function $56cbbe02a148f8ee$export$be2f13183561cb() {
        const { productEntitlementDetails: productEntitlementDetails, appEditions: appEditions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const jswEdition = appEditions?.software;
        const entitlementDetails = productEntitlementDetails?.[0, $c06e1abca7c13910$export$1346c9aa3cbb477d];
        const billingSourceSystem = entitlementDetails?.billingSourceSystem || 'HAMS';
        const trialEndTime = entitlementDetails?.trialEndTime;
        const trialDaysLeft = (0, (0, parcelRequire("1laI5")).getTrialDaysLeft)(trialEndTime);
        const isInTrial = !!trialDaysLeft && trialDaysLeft > 0;
        return {
            jswEdition: jswEdition,
            billingSourceSystem: billingSourceSystem,
            trialDaysLeft: trialDaysLeft,
            isInTrial: isInTrial,
            trialEndTime: trialEndTime
        };
    }
});
parcelRegister("1laI5", function(module, exports) {
    $parcel$export(module.exports, "getTrialDaysLeft", ()=>$39ed199f3e5d9f33$export$954628993bf3188e);
    $parcel$export(module.exports, "projectToApplicationKey", ()=>$39ed199f3e5d9f33$export$1af4fd6f5c543149);
    var $2vSU6;
    const $39ed199f3e5d9f33$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
    const $39ed199f3e5d9f33$export$954628993bf3188e = (trialEndTime)=>trialEndTime && Math.ceil(($39ed199f3e5d9f33$export$9dbbf537dffaafc7(trialEndTime) - Date.now()) / 86400000);
    const $39ed199f3e5d9f33$export$271517afaa0c15eb = (trialEndTime)=>{
        const trialDaysLeft = $39ed199f3e5d9f33$export$954628993bf3188e(trialEndTime);
        return !trialDaysLeft || trialDaysLeft < 0;
    };
    const $39ed199f3e5d9f33$export$1af4fd6f5c543149 = (project)=>{
        switch(project){
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                return 0, $c06e1abca7c13910$export$202f50ee62667e32;
            default:
                throw new Error(`Unsupported project: ${project}`);
        }
    };
});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';
parcelRegister("jTugD", function(module, exports) {
    $parcel$export(module.exports, "useCanShowExperiment", ()=>$64b4d7c7a81ce18b$export$acc3825c421a3bd7);
    var $5uXOq = parcelRequire("5uXOq");
    var $fG5AJ;
    function $64b4d7c7a81ce18b$export$acc3825c421a3bd7({ skip: skip }) {
        const [canShowExperiment, setCanShowExperiment] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = (0, (0, parcelRequire("fG5AJ")).useChoreographer)('jira-loss-aversion-standard', {
            start: ()=>setCanShowExperiment(true),
            stop: ()=>setCanShowExperiment(false)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!skip) startMessage();
            return ()=>{
                stopMessage();
            };
        }, [
            startMessage,
            stopMessage,
            skip
        ]);
        return {
            canShowExperiment: canShowExperiment
        };
    }
});
parcelRegister("fG5AJ", function(module, exports) {
    $parcel$export(module.exports, "getPendoPlugin", ()=>$596f0fde3f3a2d5a$export$3d3a86b2d636214b);
    $parcel$export(module.exports, "useChoreographer", ()=>$596f0fde3f3a2d5a$export$9f0e2488ffd90f11);
    $parcel$export(module.exports, "ChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    $parcel$export(module.exports, "useChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$2eb1efa814fe4a);
    $parcel$export(module.exports, "useChoreographedRender", ()=>$596f0fde3f3a2d5a$export$2cfd68294be82811);
    var $5uXOq = parcelRequire("5uXOq");
    var $4zICj;
    var $8r6xd;
    var $TTRxY;
    var $j8DrX;
    var $7qPn9;
    const $596f0fde3f3a2d5a$var$environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment')) ?? 'prod';
    const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
        if (false) return {
            useChoreographer: (..._)=>({
                    startMessage: ()=>Promise.resolve(''),
                    stopMessage: ()=>{}
                })
        };
        return (0, (0, parcelRequire("4zICj")).choreographerFactory)((0, (0, parcelRequire("TTRxY")).ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
    };
    let $596f0fde3f3a2d5a$var$pendoPlugin;
    function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
        if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, (0, parcelRequire("8r6xd")).PendoChoreographerPlugin)(env, {
            sourceProductId: (0, (0, parcelRequire("TTRxY")).ProductIds).JIRA
        });
        return $596f0fde3f3a2d5a$var$pendoPlugin;
    }
    const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11 } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
    const $596f0fde3f3a2d5a$export$3ff96dbefca6b00d = (0, $5uXOq.createContext)({
        isAlreadyChoreographedAtAncestor: false
    });
    const $596f0fde3f3a2d5a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $596f0fde3f3a2d5a$export$2eb1efa814fe4a();
        const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
            start: ()=>setShouldRender(true)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!isAlreadyChoreographedAtAncestor) {
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                startMessageAsync();
                return ()=>{
                    stopMessage();
                };
            }
        }, [
            onMessageDisposition,
            startMessage,
            stopMessage,
            isAlreadyChoreographedAtAncestor
        ]);
        return shouldRender || isAlreadyChoreographedAtAncestor;
    };
});
parcelRegister("e0tHE", function(module, exports) {
    $parcel$export(module.exports, "useFireExposureEvents", ()=>$39b82b161d35b62b$export$5659c1a3e6829401);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $5IPCv;
    var $8zOmE;
    var $lQj7F;
    const $39b82b161d35b62b$export$5659c1a3e6829401 = ({ skip: skip, experimentName: experimentName, extraAnalytics: extraAnalytics })=>{
        const { cohort: cohort } = (0, (0, parcelRequire("lQj7F")).useExperimentEnrollment)({
            experimentName: experimentName,
            skip: skip
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireExposureEvents = (0, $5uXOq.useCallback)(()=>{
            if (skip) return;
            (0, (0, parcelRequire("5IPCv")).default).manuallyLogExperimentExposure(experimentName);
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'jlaFeature exposed', {
                experimentName: experimentName,
                cohort: cohort,
                ...extraAnalytics
            });
        }, [
            createAnalyticsEvent,
            cohort,
            skip,
            extraAnalytics,
            experimentName
        ]);
        return {
            fireExposureEvents: fireExposureEvents
        };
    };
});
parcelRegister("5p0uL", function(module, exports) {
    $parcel$export(module.exports, "setHasSeenModal", ()=>$afd6108b32a9dfad$export$43ffcd9228973911);
    var $eEPUd;
    const $afd6108b32a9dfad$export$43ffcd9228973911 = (expermientName, isUrgent)=>{
        if (expermientName === (0, $c173c7124ea4b2f6$export$998e8261e98c7d7d)) isUrgent ? (0, (0, parcelRequire("eEPUd")).setHasSeenUrgentModalAA)() : (0, (0, parcelRequire("eEPUd")).setHasSeenFirstModalAA)();
        else isUrgent ? (0, (0, parcelRequire("eEPUd")).setHasSeenUrgentModalAB)() : (0, (0, parcelRequire("eEPUd")).setHasSeenFirstModalAB)();
    };
});
parcelRegister("9SAh4", function(module, exports) {
    $parcel$export(module.exports, "JiraLossAversionModal", ()=>$9abac46c42ac558a$export$bf5226ec0d5ecf12);
    var $fv2W2;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $39xOx;
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    var $8zOmE;
    var $2NMNM;
    var $koeKL;
    var $cNd4s;
    var $d2jVW;
    var $1RAA9;
    var $6ERtZ;
    var $hfMui;
    const $9abac46c42ac558a$export$bf5226ec0d5ecf12 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "jiraLossAversionModal",
            packageName: "jiraLossAversion",
            teamName: "luna-growth",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "loss-aversion.ui.loss-aversion-modal.jira-loss-aversion-modal-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9abac46c42ac558a$export$a562bad7894ec750, null)));
    const $9abac46c42ac558a$var$GB_IN_BYTES = 1000000000;
    const $9abac46c42ac558a$var$bytesToGB = (bytes)=>bytes / $9abac46c42ac558a$var$GB_IN_BYTES;
    const $9abac46c42ac558a$export$a562bad7894ec750 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { billingSourceSystem: billingSourceSystem } = (0, (0, parcelRequire("d2jVW")).useTrialDetails)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const shouldLoadHamsUserCount = billingSourceSystem !== 'CCP' && isSiteAdmin && (0, (0, parcelRequire("4R6GH")).fg)('jira_loss_aversion_standard_hams');
        const [hamsUserCount, setHamsUserCount] = (0, $5uXOq.useState)(1);
        const [loadingHamsUserCount, setLoadingHamsUserCount] = (0, $5uXOq.useState)(shouldLoadHamsUserCount);
        const [hamsUserCountError, setHamsUserCountError] = (0, $5uXOq.useState)(null);
        const data = (0, $8Uumt.useLazyLoadQuery)((0, (0, parcelRequire("fv2W2")).default), {
            cloudId: cloudId,
            isCCP: billingSourceSystem === 'CCP'
        });
        (0, $5uXOq.useEffect)(()=>{
            const fetchData = async ()=>{
                if (!shouldLoadHamsUserCount) return;
                try {
                    const response = await (0, (0, parcelRequire("eusud")).performGetRequestWithRetry)(`/gateway/api/billing-ux/cloud/${cloudId}/billing/entitlement-group-detail`);
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetched hamsUserCount', {});
                    const jiraEntitlement = response.entitlements.find((entitlement)=>entitlement.productKey === 'jira-software.ondemand');
                    const usage = jiraEntitlement?.usages?.find((usages)=>usages.unitType === 'USER');
                    setHamsUserCount(usage?.unitCount || 1);
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'fetchHamsUserCountWithRetry',
                            packageName: 'jiraLossAversion'
                        }
                    });
                    setHamsUserCountError(error.message || 'Unknown HAMS user count fetch error');
                } finally{
                    setLoadingHamsUserCount(false);
                }
            };
            fetchData();
        }, [
            cloudId,
            shouldLoadHamsUserCount,
            setLoadingHamsUserCount,
            setHamsUserCount,
            createAnalyticsEvent
        ]);
        const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
        const entitlement = entitlementInfo?.entitlement;
        const configurePayment = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePayment;
        const upgradeUrl = configurePayment?.experienceUrl || '/admin/billing/applications';
        if (!configurePayment?.experienceUrl) (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'paymentUrlUndefined',
                packageName: 'jiraLossAversion',
                teamName: 'luna-growth'
            },
            attributes: {
                isSiteAdmin: isSiteAdmin,
                billingSourceSystem: billingSourceSystem,
                cloudId: cloudId
            }
        });
        const userCanPay = !!configurePayment?.isAvailableToUser;
        const userCount = entitlementInfo?.__typename === 'CommerceEntitlementInfoCcp' ? entitlementInfo.entitlement?.subscription?.chargeDetails?.chargeQuantities?.[0]?.quantity || 1 : 1;
        if (hamsUserCountError) throw new Error(hamsUserCountError);
        if (loadingHamsUserCount) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        const relevantUserCount = billingSourceSystem === 'CCP' ? userCount : hamsUserCount;
        if (relevantUserCount > 10) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hfMui")).UserLimitModal), {
            userCanPay: userCanPay,
            userCount: relevantUserCount,
            upgradeUrl: upgradeUrl
        });
        const attachmentStorageUsed = data?.jira?.attachmentStorageUsed || 0;
        const storageUsedInGB = $9abac46c42ac558a$var$bytesToGB(attachmentStorageUsed);
        if (attachmentStorageUsed > 2 * $9abac46c42ac558a$var$GB_IN_BYTES) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ERtZ")).StorageModal), {
            userCanPay: userCanPay,
            upgradeUrl: upgradeUrl,
            storageUsedInGB: storageUsedInGB
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1RAA9")).SplitPanelModal), {
            userCanPay: userCanPay,
            upgradeUrl: upgradeUrl
        });
    };
});
parcelRegister("fv2W2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92f06e5a22e4b753$export$2e2bcd8739ae039);
    const $92f06e5a22e4b753$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isCCP"
            }
        ], v1 = {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "applicationKey",
                            "value": "JIRA_SOFTWARE"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "attachmentStorageUsed"
                }
            ]
        }, v2 = [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ], v3 = [
            {
                "kind": "Literal",
                "name": "hamsProductKey",
                "value": "jira-software.ondemand"
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "experienceUrl"
        }, v5 = {
            "kind": "ScalarField",
            "name": "isAvailableToUser"
        }, v6 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v7 = {
            "concreteType": "CcpChargeDetails",
            "kind": "LinkedField",
            "name": "chargeDetails",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CcpChargeQuantity",
                    "kind": "LinkedField",
                    "name": "chargeQuantities",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "quantity"
                        }
                    ]
                }
            ]
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = [
            v8
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "lossAversionModalQuery",
                "selections": [
                    v1,
                    {
                        "args": v2,
                        "concreteType": "TenantContext",
                        "kind": "LinkedField",
                        "name": "tenantContexts",
                        "plural": true,
                        "selections": [
                            {
                                "args": v3,
                                "kind": "LinkedField",
                                "name": "entitlementInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "entitlement",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "subscription",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "accountDetails",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "invoiceGroup",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "experienceCapabilities",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "configurePayment",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v4,
                                                                                    v5
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isCCP",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v6,
                                                    {
                                                        "concreteType": "CcpEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlement",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "CcpSubscription",
                                                                "kind": "LinkedField",
                                                                "name": "subscription",
                                                                "plural": false,
                                                                "selections": [
                                                                    v7
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "CommerceEntitlementInfoCcp"
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "lossAversionModalQuery",
                "selections": [
                    v1,
                    {
                        "args": v2,
                        "concreteType": "TenantContext",
                        "kind": "LinkedField",
                        "name": "tenantContexts",
                        "plural": true,
                        "selections": [
                            {
                                "args": v3,
                                "kind": "LinkedField",
                                "name": "entitlementInfo",
                                "plural": false,
                                "selections": [
                                    v6,
                                    {
                                        "kind": "LinkedField",
                                        "name": "entitlement",
                                        "plural": false,
                                        "selections": [
                                            v6,
                                            {
                                                "kind": "LinkedField",
                                                "name": "subscription",
                                                "plural": false,
                                                "selections": [
                                                    v6,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "accountDetails",
                                                        "plural": false,
                                                        "selections": [
                                                            v6,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "invoiceGroup",
                                                                "plural": false,
                                                                "selections": [
                                                                    v6,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "experienceCapabilities",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v6,
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "configurePayment",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v6,
                                                                                    v4,
                                                                                    v5
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v9,
                                                                        "type": "CcpInvoiceGroup"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": v9,
                                                        "type": "CcpSubscription"
                                                    }
                                                ]
                                            },
                                            v8
                                        ]
                                    },
                                    {
                                        "condition": "isCCP",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "CcpEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlement",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "CcpSubscription",
                                                                "kind": "LinkedField",
                                                                "name": "subscription",
                                                                "plural": false,
                                                                "selections": [
                                                                    v7,
                                                                    v8
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "CommerceEntitlementInfoCcp"
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "4b8295853745181bd23267965a269c9646cc295b42d4236212b5283e4cea3b55",
                "metadata": {},
                "name": "lossAversionModalQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $92f06e5a22e4b753$var$node.hash = "f499aee268fbbbae058f6d4c13ba40dd";
    var $92f06e5a22e4b753$export$2e2bcd8739ae039 = $92f06e5a22e4b753$var$node;
});
parcelRegister("1RAA9", function(module, exports) {
    $parcel$export(module.exports, "SplitPanelModal", ()=>$461ab3e2b8607d1d$export$c18002dc7c50901b);
    var $5uXOq = parcelRequire("5uXOq");
    var $2gQ83;
    var $eCeGD;
    var $1GGwS;
    var $dC5iT;
    var $8CUq3;
    var $8Vj85;
    var $gf23f;
    var $gOC1a;
    var $39xOx;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $2NMNM;
    var $frhEJ;
    var $9o6tH;
    var $d2jVW;
    var $4IUNo;
    var $jp1ch;
    var $rp9KL;
    var $47JDo;
    var $1CzE7;
    var $g1ZdZ;
    var $icj7A;
    const $461ab3e2b8607d1d$export$c18002dc7c50901b = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "splitPanelModal",
            packageName: "jiraLossAversion",
            teamName: "luna-growth",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($461ab3e2b8607d1d$export$ee50c7bc3828b59b, {
            userCanPay: userCanPay,
            upgradeUrl: upgradeUrl
        }));
    const $461ab3e2b8607d1d$export$ee50c7bc3828b59b = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [showModal, setShowModal] = (0, $5uXOq.useState)(true);
        const { isUrgent: isUrgent } = (0, (0, parcelRequire("9o6tH")).useExperimentEligibility)((0, $c173c7124ea4b2f6$export$855e843fe464d553), false);
        const { trialDaysLeft: trialDaysLeft } = (0, (0, parcelRequire("d2jVW")).useTrialDetails)();
        const origin = new (0, (0, parcelRequire("2gQ83")).default)({
            product: 'jira'
        });
        const addPaymentDetailsUrl = origin.addToUrl(upgradeUrl);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("frhEJ")).fireButtonAnalytics)(createAnalyticsEvent, 'jlaCloseButton', {
                trialDaysLeft: trialDaysLeft,
                userCanPay: userCanPay,
                modal: 'jlaSplitPanel'
            });
            setShowModal(false);
        }, [
            createAnalyticsEvent,
            trialDaysLeft,
            userCanPay
        ]);
        const onAddPaymentDetails = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("frhEJ")).fireButtonAnalytics)(createAnalyticsEvent, 'jlaAddPaymentButton', {
                trialDaysLeft: trialDaysLeft,
                userCanPay: userCanPay,
                modal: 'jlaSplitPanel'
            });
            setShowModal(false);
        }, [
            createAnalyticsEvent,
            trialDaysLeft,
            userCanPay
        ]);
        const getSubTitleText = (0, $5uXOq.useCallback)(()=>{
            if (isUrgent) return userCanPay ? formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardSubTitleUrgent) : formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardSubTitleUrgentNoPay);
            return userCanPay ? formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardSubTitle) : formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardSubTitleNoPay);
        }, [
            formatMessage,
            isUrgent,
            userCanPay
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "jiraLossAversionSplit"
        }, showModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gOC1a")).Modal), {
            height: 536,
            title: formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardTitle, {
                trialDaysLeft: trialDaysLeft
            }),
            subtitle: getSubTitleText(),
            onClose: onClose,
            testId: "loss-aversion.ui.loss-aversion-modal.split-panel",
            actions: userCanPay && addPaymentDetailsUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                onClick: onClose,
                appearance: "subtle"
            }, formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardSecondaryCtaText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1GGwS")).default), {
                onClick: onAddPaymentDetails,
                appearance: "primary",
                href: addPaymentDetailsUrl,
                target: "_blank"
            }, formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardPrimaryCtaText))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                onClick: onClose,
                appearance: "subtle"
            }, formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardPrimaryCtaTextNoPay)),
            right: userCanPay ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $461ab3e2b8607d1d$var$carouselStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Vj85")).Carousel), {
                height: 325
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gf23f")).CarouselSlide), {
                title: formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardCarouslSlideUserLimit)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4IUNo")).AddPeopleGraphic), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gf23f")).CarouselSlide), {
                title: formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardCarouslSlideAuditLog)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("rp9KL")).AuditLogGraphic), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gf23f")).CarouselSlide), {
                title: formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardCarouslSlideUserAutomation)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47JDo")).AutomationGraphic), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gf23f")).CarouselSlide), {
                title: formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardCarouslSlideUserPermissions)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1CzE7")).UserPermissionsGraphic), null)))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $461ab3e2b8607d1d$var$carouselStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Vj85")).Carousel), {
                height: 325
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gf23f")).CarouselSlide), {
                title: formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardCarouslSlideUserLimit)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4IUNo")).AddPeopleGraphic), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gf23f")).CarouselSlide), {
                title: formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardCarouslSlideStorageLimit)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jp1ch")).AttachmentsGraphic), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gf23f")).CarouselSlide), {
                title: formatMessage((0, (0, parcelRequire("icj7A")).default).jswStandardCarouslSlideUserAutomation)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47JDo")).AutomationGraphic), null))))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g1ZdZ")).BenefitsListSection), {
            canPay: userCanPay
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                experiment: (0, $c173c7124ea4b2f6$export$855e843fe464d553),
                trialDaysLeft: trialDaysLeft,
                userCanPay: userCanPay
            }
        }));
    };
    const $461ab3e2b8607d1d$var$carouselStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'auto'
    });
});
parcelRegister("1GGwS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9768e745d0380796$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhmo0;
    var $fuBHX;
    const $9768e745d0380796$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("fuBHX")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "LinkButton"
        }, baseProps.children);
    };
    const $9768e745d0380796$var$WithRef = (0, $5uXOq.forwardRef)($9768e745d0380796$var$LinkButtonBase);
    const $9768e745d0380796$var$LinkButton = (0, $5uXOq.memo)($9768e745d0380796$var$WithRef);
    var $9768e745d0380796$export$2e2bcd8739ae039 = $9768e745d0380796$var$LinkButton;
});
parcelRegister("8Vj85", function(module, exports) {
    $parcel$export(module.exports, "Carousel", ()=>$c236740d9c48252d$export$144901db2ea8e967);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $fmJTX;
    var $6s76W;
    var $35XSW;
    var $lObw7;
    var $8Sbj3;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $bsLwX;
    const $c236740d9c48252d$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflowX: 'hidden',
        width: '100%',
        paddingBlock: 'space.500',
        paddingInline: 'space.400'
    });
    const $c236740d9c48252d$export$144901db2ea8e967 = ({ children: children, onSlideChange: onSlideChange, height: height = 405 })=>{
        const [index, setIndex] = (0, $5uXOq.useState)(0);
        const slides = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children);
        const slide = slides[index];
        const count = slides.length;
        const handleOnPrevious = (0, $5uXOq.useCallback)(()=>{
            const prevIndex = index - 1 < 0 ? count - 1 : index - 1;
            setIndex(prevIndex);
            onSlideChange?.({
                index: prevIndex,
                previousIndex: index
            });
        }, [
            index,
            count,
            onSlideChange
        ]);
        const handleOnNext = (0, $5uXOq.useCallback)(()=>{
            const nextIndex = index + 1 < count ? index + 1 : 0;
            setIndex(nextIndex);
            onSlideChange?.({
                index: nextIndex,
                previousIndex: index
            });
        }, [
            index,
            count,
            onSlideChange
        ]);
        const handleOnSelectIndex = (0, $5uXOq.useCallback)(({ index: nextIndex })=>{
            setIndex(nextIndex);
            onSlideChange?.({
                index: nextIndex,
                previousIndex: index
            });
        }, [
            onSlideChange,
            index
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200",
            xcss: $c236740d9c48252d$var$containerStyles,
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("35XSW")).default), {
            exitThenEnter: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            key: index
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Sbj3")).default), {
            enterFrom: "right",
            exitTo: "left",
            fade: "inout",
            duration: (0, (0, parcelRequire("lObw7")).mediumDurationMs)
        }, (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    height: height
                },
                ...props,
                id: `slide${index}`
            }, slide)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            alignInline: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))),
            label: "Previous",
            onClick: handleOnPrevious
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bsLwX")).default), {
            selectedIndex: index,
            values: slides.map((_, idx)=>idx),
            onSelect: handleOnSelectIndex,
            appearance: "primary",
            ariaControls: "slide"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("6s76W"))))),
            label: "Next",
            onClick: handleOnNext
        })));
    };
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("bsLwX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22e0f47b276ff587$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $6QvkM;
    var $eGmKJ;
    var $dC5iT;
    var $f5TWP;
    var $eWICW;
    var $77Kws;
    const $22e0f47b276ff587$var$packageName = "platform-pkg";
    const $22e0f47b276ff587$var$packageVersion = "0.0.0-use.local";
    const $22e0f47b276ff587$var$ProgressDots = ({ appearance: appearance = 'default', ariaControls: ariaControls = 'panel', ariaLabel: ariaLabel = 'tab', size: size = 'default', spacing: gutter = 'comfortable', selectedIndex: selectedIndex, testId: testId, values: values, onSelect: onSelect })=>{
        const tablistRef = (0, $5uXOq.useRef)(null);
        const onSelectWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onSelect || (0, (0, parcelRequire("eGmKJ")).default),
            action: 'selected',
            componentName: 'progressIndicator',
            packageName: $22e0f47b276ff587$var$packageName,
            packageVersion: $22e0f47b276ff587$var$packageVersion
        });
        const [inlineGapValue, rawGapValue] = (0, (0, parcelRequire("eWICW")).progressIndicatorGapMap)[gutter][size];
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const indicators = Array.from(tablistRef.current.children);
            if (!indicators.includes(event.target)) return;
            const isLeft = event.key === 'ArrowLeft';
            const isRight = event.key === 'ArrowRight';
            if (!isLeft && !isRight) return;
            const isAlpha = isLeft && selectedIndex === 0;
            const isOmega = isRight && selectedIndex === values.length - 1;
            if (isAlpha || isOmega) return;
            const index = isLeft ? selectedIndex - 1 : selectedIndex + 1;
            if (onSelect) onSelectWithAnalytics({
                event: event,
                index: index
            });
            if (typeof indicators[index].focus === 'function') indicators[index].focus();
        }, [
            onSelectWithAnalytics,
            selectedIndex,
            values,
            onSelect
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!onSelect) return 0, (0, parcelRequire("eGmKJ")).default;
            return (0, (0, parcelRequire("cBeZP")).bind)(document, {
                type: 'keydown',
                listener: handleKeyDown,
                options: {
                    capture: false
                }
            });
        }, [
            onSelect,
            handleKeyDown
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            style: {
                [(0, (0, parcelRequire("eWICW")).varDotsSize)]: `${(0, (0, parcelRequire("eWICW")).sizes)[size]}px`,
                [(0, (0, parcelRequire("eWICW")).varDotsMargin)]: rawGapValue
            },
            role: onSelect && 'tablist'
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            testId: testId,
            ref: (r)=>{
                tablistRef.current = r;
            },
            alignInline: "center",
            space: inlineGapValue
        }, values.map((_, index)=>{
            const isSelected = selectedIndex === index;
            const tabId = `${ariaLabel}${index}`;
            const panelId = `${ariaControls}${index}`;
            const indicatorTestId = testId && `${testId}-ind-${index}`;
            return onSelect ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("77Kws")).ButtonIndicator), {
                key: index,
                testId: indicatorTestId,
                appearance: appearance,
                isSelected: isSelected,
                tabId: tabId,
                panelId: panelId,
                onClick: (event)=>onSelectWithAnalytics({
                        event: event,
                        index: index
                    })
            }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("77Kws")).PresentationalIndicator), {
                key: index,
                testId: indicatorTestId,
                appearance: appearance,
                isSelected: isSelected
            });
        })));
    };
    var $22e0f47b276ff587$export$2e2bcd8739ae039 = $22e0f47b276ff587$var$ProgressDots;
});
parcelRegister("eWICW", function(module, exports) {
    $parcel$export(module.exports, "progressIndicatorGapMap", ()=>$8a09a5d4504a0baf$export$c7b941bbc227445b);
    $parcel$export(module.exports, "sizes", ()=>$8a09a5d4504a0baf$export$c647cb0ee6e282fe);
    $parcel$export(module.exports, "varDotsSize", ()=>$8a09a5d4504a0baf$export$83c4f86b79228049);
    $parcel$export(module.exports, "varDotsMargin", ()=>$8a09a5d4504a0baf$export$b391856a24c21681);
    const $8a09a5d4504a0baf$export$c7b941bbc227445b = {
        comfortable: {
            default: [
                'space.100',
                "var(--ds-space-100, 8px)"
            ],
            large: [
                'space.150',
                "var(--ds-space-150, 12px)"
            ]
        },
        cozy: {
            default: [
                'space.075',
                "var(--ds-space-075, 6px)"
            ],
            large: [
                'space.100',
                "var(--ds-space-100, 8px)"
            ]
        },
        compact: {
            default: [
                'space.050',
                "var(--ds-space-050, 4px)"
            ],
            large: [
                'space.075',
                "var(--ds-space-075, 6px)"
            ]
        }
    };
    const $8a09a5d4504a0baf$export$c647cb0ee6e282fe = {
        default: 8,
        large: 12
    };
    const $8a09a5d4504a0baf$export$83c4f86b79228049 = '--ds-dots-size';
    const $8a09a5d4504a0baf$export$b391856a24c21681 = '--ds-dots-margin';
});
parcelRegister("77Kws", function(module, exports) {
    $parcel$export(module.exports, "PresentationalIndicator", ()=>$95d068879db54665$export$ec3c81af58a0c4e7);
    $parcel$export(module.exports, "ButtonIndicator", ()=>$95d068879db54665$export$3716cb524d6018c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $jldZL;
    var $eWICW;
    const $95d068879db54665$var$colorMap = {
        default: (0, (0, parcelRequire("8CUq3")).xcss)({
            backgroundColor: 'elevation.surface',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-bold, #758195)"}`
        }),
        help: (0, (0, parcelRequire("8CUq3")).xcss)({
            backgroundColor: 'elevation.surface',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-bold, #758195)"}`
        }),
        inverted: (0, (0, parcelRequire("8CUq3")).xcss)({
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-inverse, #FFFFFF)"}`
        }),
        primary: (0, (0, parcelRequire("8CUq3")).xcss)({
            backgroundColor: 'elevation.surface',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-bold, #758195)"}`
        })
    };
    const $95d068879db54665$var$selectedColorMap = {
        default: (0, (0, parcelRequire("8CUq3")).xcss)({
            backgroundColor: "var(--ds-icon, #44546F)"
        }),
        help: (0, (0, parcelRequire("8CUq3")).xcss)({
            backgroundColor: "var(--ds-icon-discovery, #8270DB)"
        }),
        inverted: (0, (0, parcelRequire("8CUq3")).xcss)({
            backgroundColor: "var(--ds-icon-inverse, #FFFFFF)"
        }),
        primary: (0, (0, parcelRequire("8CUq3")).xcss)({
            backgroundColor: "var(--ds-icon-brand, #0C66E4)"
        })
    };
    const $95d068879db54665$var$commonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `var(${(0, (0, parcelRequire("eWICW")).varDotsSize)})`,
        height: `var(${(0, (0, parcelRequire("eWICW")).varDotsSize)})`,
        position: 'relative',
        borderRadius: 'border.radius.circle',
        '::before': {
            display: 'block',
            width: `calc(var(${(0, (0, parcelRequire("eWICW")).varDotsSize)}) + var(${(0, (0, parcelRequire("eWICW")).varDotsMargin)}))`,
            height: `calc(var(${(0, (0, parcelRequire("eWICW")).varDotsSize)}) + var(${(0, (0, parcelRequire("eWICW")).varDotsMargin)}))`,
            position: 'absolute',
            content: '""',
            insetBlockStart: `calc(-1 * var(${(0, (0, parcelRequire("eWICW")).varDotsMargin)}) / 2)`,
            insetInlineStart: `calc(-1 * var(${(0, (0, parcelRequire("eWICW")).varDotsMargin)}) / 2)`
        }
    });
    const $95d068879db54665$var$buttonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0',
        cursor: 'pointer',
        outline: 0
    });
    const $95d068879db54665$export$ec3c81af58a0c4e7 = ({ appearance: appearance, isSelected: isSelected, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            xcss: [
                $95d068879db54665$var$commonStyles,
                appearance === 'default' && !isSelected && $95d068879db54665$var$colorMap['default'],
                appearance === 'help' && !isSelected && $95d068879db54665$var$colorMap['help'],
                appearance === 'inverted' && !isSelected && $95d068879db54665$var$colorMap['inverted'],
                appearance === 'primary' && !isSelected && $95d068879db54665$var$colorMap['primary'],
                appearance === 'default' && isSelected && $95d068879db54665$var$selectedColorMap['default'],
                appearance === 'help' && isSelected && $95d068879db54665$var$selectedColorMap['help'],
                appearance === 'inverted' && isSelected && $95d068879db54665$var$selectedColorMap['inverted'],
                appearance === 'primary' && isSelected && $95d068879db54665$var$selectedColorMap['primary']
            ]
        });
    const $95d068879db54665$export$3716cb524d6018c1 = ({ appearance: appearance, panelId: panelId, tabId: tabId, isSelected: isSelected, onClick: onClick, testId: testId })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            role: "tab",
            xcss: [
                $95d068879db54665$var$commonStyles,
                $95d068879db54665$var$buttonStyles,
                appearance === 'default' && !isSelected && $95d068879db54665$var$colorMap['default'],
                appearance === 'help' && !isSelected && $95d068879db54665$var$colorMap['help'],
                appearance === 'inverted' && !isSelected && $95d068879db54665$var$colorMap['inverted'],
                appearance === 'primary' && !isSelected && $95d068879db54665$var$colorMap['primary'],
                appearance === 'default' && isSelected && $95d068879db54665$var$selectedColorMap['default'],
                appearance === 'help' && isSelected && $95d068879db54665$var$selectedColorMap['help'],
                appearance === 'inverted' && isSelected && $95d068879db54665$var$selectedColorMap['inverted'],
                appearance === 'primary' && isSelected && $95d068879db54665$var$selectedColorMap['primary']
            ],
            "aria-controls": panelId,
            "aria-selected": isSelected,
            id: tabId,
            onClick: onClick,
            tabIndex: isSelected ? -1 : undefined,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, tabId));
    };
});
parcelRegister("gf23f", function(module, exports) {
    $parcel$export(module.exports, "CarouselSlide", ()=>$05957c7ee91a38cd$export$cabb5ccfbd60cbd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    const $05957c7ee91a38cd$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%'
    });
    const $05957c7ee91a38cd$var$headingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textAlign: 'center'
    });
    const $05957c7ee91a38cd$var$childrenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflowY: 'auto',
        width: '100%',
        flexGrow: 1,
        height: '100%'
    });
    const $05957c7ee91a38cd$var$titleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        textAlign: 'center',
        marginTop: 'space.0'
    });
    const $05957c7ee91a38cd$export$cabb5ccfbd60cbd4 = ({ heading: heading, children: children, title: title })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200",
            alignInline: "center",
            xcss: $05957c7ee91a38cd$var$containerStyles,
            testId: "growth-pattern-library-modal-carousel-slide"
        }, heading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $05957c7ee91a38cd$var$headingStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            as: "span",
            size: "small"
        }, heading)) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $05957c7ee91a38cd$var$childrenStyles
        }, children), title ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "p",
            xcss: $05957c7ee91a38cd$var$titleStyles
        }, title) : null);
});
parcelRegister("gOC1a", function(module, exports) {
    $parcel$export(module.exports, "Modal", ()=>$e2c0d8099f9484cc$export$2b77a92f1a5ad772);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $dC5iT;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $h9kUS;
    var $3eRhH;
    var $1D91U;
    var $eKDWz;
    const $e2c0d8099f9484cc$var$container = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflowY: 'auto',
        height: '100%',
        [(0, (0, parcelRequire("h9kUS")).media).above.sm]: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr'
        }
    });
    const $e2c0d8099f9484cc$var$stack = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '100%',
        padding: 'space.600',
        overflowY: 'auto'
    });
    const $e2c0d8099f9484cc$var$rightContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'none',
        [(0, (0, parcelRequire("h9kUS")).media).above.sm]: {
            backgroundColor: 'color.background.accent.gray.subtlest',
            display: 'flex',
            width: '100%',
            overflowY: 'auto',
            borderTopRightRadius: 'border.radius',
            borderBottomRightRadius: 'border.radius'
        }
    });
    const $e2c0d8099f9484cc$export$2b77a92f1a5ad772 = ({ logo: logo, title: title, subtitle: subtitle, children: children, actions: actions, right: right, ...modalProps })=>{
        const includesRight = right !== undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: includesRight ? 'x-large' : undefined,
            autoFocus: false,
            ...modalProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: includesRight && $e2c0d8099f9484cc$var$container
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.400",
            xcss: $e2c0d8099f9484cc$var$stack
        }, logo, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eKDWz")).ModalTitle), null, title), subtitle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle",
            size: "medium"
        }, subtitle) : null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3eRhH")).ModalBody), null, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1D91U")).ModalFooter), null, actions)), includesRight && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e2c0d8099f9484cc$var$rightContainer
        }, right)));
    };
});
parcelRegister("3eRhH", function(module, exports) {
    $parcel$export(module.exports, "ModalBody", ()=>$73e2dd8eeb5927c9$export$cb540d8b0ef7906c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2alJM = parcelRequire("2alJM");
    var $kdO7l;
    var $luBm6;
    var $8CUq3;
    const $73e2dd8eeb5927c9$var$container = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: '1 1 auto',
        overflowY: 'auto'
    });
    const $73e2dd8eeb5927c9$export$cb540d8b0ef7906c = (props)=>{
        const { children: children, testId: userDefinedTestId } = props;
        const { testId: modalTestId } = (0, (0, parcelRequire("kdO7l")).useModal)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $2alJM.TouchScrollable), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.300",
            xcss: $73e2dd8eeb5927c9$var$container,
            testId: testId
        }, children));
    };
});
parcelRegister("1D91U", function(module, exports) {
    $parcel$export(module.exports, "ModalFooter", ()=>$09f56d2ec73642d3$export$519437715052e656);
    var $5uXOq = parcelRequire("5uXOq");
    var $kdO7l;
    var $f5TWP;
    var $8CUq3;
    const $09f56d2ec73642d3$var$wrapStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexWrap: 'wrap-reverse'
    });
    const $09f56d2ec73642d3$export$519437715052e656 = (props)=>{
        const { children: children, testId: userDefinedTestId } = props;
        const { testId: modalTestId } = (0, (0, parcelRequire("kdO7l")).useModal)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignInline: "end",
            testId: testId,
            space: "space.150",
            xcss: $09f56d2ec73642d3$var$wrapStyles
        }, children);
    };
});
parcelRegister("eKDWz", function(module, exports) {
    $parcel$export(module.exports, "ModalTitle", ()=>$68ed48a1d2d2d42e$export$b26fae16ba5468aa);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $kdO7l;
    const $68ed48a1d2d2d42e$export$b26fae16ba5468aa = (props)=>{
        const { children: children, testId: userDefinedTestId } = props;
        const { titleId: titleId, testId: modalTestId } = (0, (0, parcelRequire("kdO7l")).useModal)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            testId: testId,
            size: "large",
            id: titleId
        }, children);
    };
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("frhEJ", function(module, exports) {
    $parcel$export(module.exports, "fireButtonAnalytics", ()=>$e1b70b40f65ce106$export$ac665b9f9662b94a);
    var $8zOmE;
    const $e1b70b40f65ce106$export$ac665b9f9662b94a = (createAnalyticsEvent, actionSubjectId, attributes)=>{
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked',
            source: 'jira'
        }), actionSubjectId, {
            ...attributes
        });
    };
    const $e1b70b40f65ce106$export$a27c21aa3ed8f0f1 = (createAnalyticsEvent, reason)=>{
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
            source: 'jira'
        }), 'experiment error', {
            reason: reason,
            experimentKey: (0, $c173c7124ea4b2f6$export$855e843fe464d553)
        });
    };
    const $e1b70b40f65ce106$export$d5afa3e4b289a23 = (createAnalyticsEvent, actionSubjectId, attributes)=>{
        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
            source: 'jira'
        }), actionSubjectId, {
            experimentKey: (0, $c173c7124ea4b2f6$export$855e843fe464d553),
            ...attributes
        });
    };
});
parcelRegister("4IUNo", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleGraphic", ()=>$4c16df57eec7ee6c$export$9a98d2fea0ed45ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $icj7A;
    function $4c16df57eec7ee6c$export$9a98d2fea0ed45ce() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "366",
            height: "276",
            viewBox: "0 0 366 276",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "200",
            height: "244",
            transform: "matrix(0.997242 -0.0742187 0.0655601 0.997849 0 15.8682)",
            fill: "#1868DB"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "172.24",
            y: "13.9958",
            width: "193",
            height: "243",
            transform: "rotate(1.512 172.24 13.9958)",
            fill: "#FCA700"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M200.349 14.738L215.445 244.499L166.059 248.175L172.24 13.9961L200.349 14.738Z",
            fill: "#09326C"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0_1210_8269)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "185",
            transform: "translate(41 40.5)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "56",
            transform: "translate(41 40.5)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip1_1210_8269)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip2_1210_8269)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip3_1210_8269)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip4_1210_8269)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M78.3264 71.5201C73.3886 69.1325 71.9461 68.7757 69.8656 68.7757C67.4244 68.7757 65.3439 69.7911 63.4853 72.6452L63.1801 73.1118C62.9305 73.496 62.875 73.6332 62.875 73.7979C62.875 73.9625 62.9582 74.0997 63.2634 74.2919L66.398 76.2403C66.5645 76.3501 66.7032 76.405 66.8419 76.405C67.0083 76.405 67.1193 76.3227 67.2857 76.0757L67.785 75.3073C68.5618 74.1272 69.2553 73.743 70.143 73.743C70.9197 73.743 71.8351 73.9625 72.9725 74.5114L76.2459 76.0482C76.5787 76.2129 76.9394 76.1306 77.1058 75.7464L78.6593 72.3434C78.8257 71.9592 78.7147 71.7122 78.3264 71.5201ZM63.9291 65.5099C68.8669 67.8975 70.3094 68.2543 72.3899 68.2543C74.8311 68.2543 76.9116 67.2389 78.7702 64.3848L79.0754 63.9182C79.325 63.534 79.3805 63.3968 79.3805 63.2321C79.3805 63.0675 79.2973 62.9303 78.9922 62.7381L75.8575 60.7897C75.691 60.6799 75.5523 60.625 75.4136 60.625C75.2472 60.625 75.1362 60.7073 74.9698 60.9543L74.4705 61.7227C73.6937 62.9028 73.0002 63.287 72.1125 63.287C71.3358 63.287 70.4204 63.0675 69.283 62.5186L66.0097 60.9818C65.6768 60.8171 65.3162 60.8994 65.1497 61.2836L63.5962 64.6866C63.4298 65.0708 63.5408 65.3178 63.9291 65.5099Z",
            fill: "#1868DB"
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#172B4D",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            fontSize: "16",
            fontWeight: "590",
            letterSpacing: "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "91",
            y: "74.1875"
        }, formatMessage((0, (0, parcelRequire("icj7A")).default).addPeopleSvgText)))), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "97",
            width: "258",
            height: "74",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "52",
            y: "97",
            width: "258",
            height: "74",
            stroke: "#DDDEE1",
            "stroke-width": "2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "61",
            y: "106",
            width: "88",
            height: "24",
            rx: "12",
            fill: "#F1F2F4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "73",
            cy: "118",
            r: "8",
            fill: "url(#pattern0_1210_8269)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "45.3333",
            height: "8",
            rx: "4",
            transform: "matrix(1 0 0 -1 85 122)",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M139.666 117.372L137.314 115.019C137.23 114.938 137.118 114.893 137.001 114.894C136.885 114.895 136.773 114.942 136.691 115.025C136.608 115.107 136.562 115.218 136.561 115.335C136.56 115.451 136.604 115.564 136.685 115.648L139.038 118L136.685 120.352C136.604 120.436 136.56 120.549 136.561 120.665C136.562 120.782 136.608 120.893 136.691 120.976C136.773 121.058 136.885 121.105 137.001 121.106C137.118 121.107 137.23 121.062 137.314 120.981L139.666 118.628L142.019 120.981C142.102 121.062 142.215 121.107 142.331 121.106C142.448 121.105 142.559 121.058 142.642 120.976C142.724 120.893 142.771 120.782 142.772 120.665C142.773 120.549 142.728 120.436 142.647 120.352L140.295 118L142.647 115.648C142.69 115.607 142.723 115.558 142.747 115.503C142.77 115.449 142.782 115.391 142.783 115.332C142.783 115.273 142.772 115.214 142.75 115.16C142.727 115.105 142.694 115.055 142.653 115.014C142.611 114.972 142.561 114.939 142.507 114.917C142.452 114.894 142.393 114.883 142.334 114.883C142.275 114.884 142.217 114.896 142.163 114.92C142.109 114.943 142.06 114.977 142.019 115.019L139.666 117.372Z",
            fill: "#44546F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "161",
            y: "106",
            width: "81.3333",
            height: "24",
            rx: "12",
            fill: "#F1F2F4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "173",
            cy: "118",
            r: "8",
            fill: "url(#pattern1_1210_8269)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "38.6667",
            height: "8",
            rx: "4",
            transform: "matrix(1 0 0 -1 185 122)",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M233 117.372L230.648 115.019C230.564 114.938 230.452 114.893 230.335 114.894C230.219 114.895 230.107 114.942 230.025 115.025C229.942 115.107 229.896 115.218 229.895 115.335C229.894 115.451 229.938 115.564 230.019 115.648L232.372 118L230.019 120.352C229.938 120.436 229.894 120.549 229.895 120.665C229.896 120.782 229.942 120.893 230.025 120.976C230.107 121.058 230.219 121.105 230.335 121.106C230.452 121.107 230.564 121.062 230.648 120.981L233 118.628L235.353 120.981C235.436 121.062 235.549 121.107 235.665 121.106C235.782 121.105 235.893 121.058 235.976 120.976C236.058 120.893 236.105 120.782 236.106 120.665C236.107 120.549 236.062 120.436 235.981 120.352L233.629 118L235.981 115.648C236.024 115.607 236.057 115.558 236.081 115.503C236.104 115.449 236.116 115.391 236.117 115.332C236.117 115.273 236.106 115.214 236.084 115.16C236.061 115.105 236.028 115.055 235.987 115.014C235.945 114.972 235.895 114.939 235.841 114.917C235.786 114.894 235.727 114.883 235.668 114.883C235.609 114.884 235.551 114.896 235.497 114.92C235.443 114.943 235.394 114.977 235.353 115.019L233 117.372Z",
            fill: "#44546F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "61",
            y: "138",
            width: "88",
            height: "24",
            rx: "12",
            fill: "#F1F2F4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "73",
            cy: "150",
            r: "8",
            fill: "url(#pattern2_1210_8269)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "45.3333",
            height: "8",
            rx: "4",
            transform: "matrix(1 0 0 -1 85 154)",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M139.666 149.372L137.314 147.019C137.23 146.938 137.118 146.893 137.001 146.894C136.885 146.895 136.773 146.942 136.691 147.025C136.608 147.107 136.562 147.218 136.561 147.335C136.56 147.451 136.604 147.564 136.685 147.648L139.038 150L136.685 152.352C136.604 152.436 136.56 152.549 136.561 152.665C136.562 152.782 136.608 152.893 136.691 152.976C136.773 153.058 136.885 153.105 137.001 153.106C137.118 153.107 137.23 153.062 137.314 152.981L139.666 150.628L142.019 152.981C142.102 153.062 142.215 153.107 142.331 153.106C142.448 153.105 142.559 153.058 142.642 152.976C142.724 152.893 142.771 152.782 142.772 152.665C142.773 152.549 142.728 152.436 142.647 152.352L140.295 150L142.647 147.648C142.69 147.607 142.723 147.558 142.747 147.503C142.77 147.449 142.782 147.391 142.783 147.332C142.783 147.273 142.772 147.214 142.75 147.16C142.727 147.105 142.694 147.055 142.653 147.014C142.611 146.972 142.561 146.939 142.507 146.917C142.452 146.894 142.393 146.883 142.334 146.883C142.275 146.884 142.217 146.896 142.163 146.92C142.109 146.943 142.06 146.977 142.019 147.019L139.666 149.372Z",
            fill: "#44546F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "261",
            y: "188",
            width: "50",
            height: "22",
            fill: "#1868DB"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("pattern", {
            id: "pattern0_1210_8269",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("use", {
            xlinkHref: "#image0_1210_8269",
            transform: "scale(0.0025)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("pattern", {
            id: "pattern1_1210_8269",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("use", {
            xlinkHref: "#image1_1210_8269",
            transform: "scale(0.0025)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("pattern", {
            id: "pattern2_1210_8269",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("use", {
            xlinkHref: "#image2_1210_8269",
            transform: "scale(0.0025)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_1210_8269"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "185",
            fill: "white",
            transform: "translate(41 40.5)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip1_1210_8269"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "236",
            height: "24",
            fill: "white",
            transform: "translate(59 56.5)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip2_1210_8269"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(59 56.5)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip3_1210_8269"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(59 56.5)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip4_1210_8269"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "16.5055",
            height: "15.78",
            fill: "white",
            transform: "translate(62.875 60.625)"
        }))));
    }
});
parcelRegister("icj7A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2814c5dbe422b016$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2814c5dbe422b016$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        jswStandardCarouslSlideUserLimit: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-user-limit",
            "defaultMessage": "Unlimited users"
        },
        jswStandardCarouslSlideAuditLog: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-audit-log",
            "defaultMessage": "Audit Log"
        },
        jswStandardCarouslSlideUserAutomation: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-user-automation",
            "defaultMessage": "Automation"
        },
        jswStandardCarouslSlideUserPermissions: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-user-permissions",
            "defaultMessage": "User permissions"
        },
        jswStandardCarouslSlideStorageLimit: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-carousl-slide-storage-limit",
            "defaultMessage": "Storage limit"
        },
        jswStandardTitle: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-title",
            "defaultMessage": "Your Standard trial ends in {trialDaysLeft, plural, one {# day} other {# days}}"
        },
        jswStandardSubTitle: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title",
            "defaultMessage": "There\u2019s still time to try advanced features. Don\u2019t lose access \u2014 add payment before your trial ends."
        },
        jswStandardSubTitleUrgent: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title-urgent",
            "defaultMessage": "Don\u2019t lose access to advanced features. Add payment before your trial ends."
        },
        jswStandardSubTitleNoPay: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title-no-pay",
            "defaultMessage": "There\u2019s still time to try advanced features. Don\u2019t lose access \u2014 ask your admin to purchase Jira Standard."
        },
        jswStandardSubTitleUrgentNoPay: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-sub-title-urgent-no-pay",
            "defaultMessage": "Don\u2019t lose access to advanced features. Ask your admin to purchase Jira Standard for your team."
        },
        jswStandardPrimaryCtaText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-primary-cta-text",
            "defaultMessage": "Add payment"
        },
        jswStandardPrimaryCtaTextNoPay: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-primary-cta-text-no-pay",
            "defaultMessage": "Close"
        },
        jswStandardSecondaryCtaText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.jsw-standard-secondary-cta-text",
            "defaultMessage": "Maybe later"
        },
        addPeopleSvgText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.add-people-svg-text",
            "defaultMessage": "Add people"
        },
        attachmentsSvgText1: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.attachments-svg-text-1",
            "defaultMessage": "Attachments"
        },
        auditLogSvgText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.audit-log-svg-text",
            "defaultMessage": "Audit log"
        },
        automationSvgText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.automation-svg-text",
            "defaultMessage": "Automation rule"
        },
        userPermissionsSvgText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.user-permissions-svg-text",
            "defaultMessage": "Project Access"
        }
    });
});
parcelRegister("jp1ch", function(module, exports) {
    $parcel$export(module.exports, "AttachmentsGraphic", ()=>$917a4f88b7f04ec9$export$d9e9ebd39e7a4e2a);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $icj7A;
    function $917a4f88b7f04ec9$export$d9e9ebd39e7a4e2a() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "395",
            height: "276",
            viewBox: "0 0 395 276",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "395",
            height: "276",
            fill: "#B3B9C4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M-6020 -813C-6020 -814.105 -6019.1 -815 -6018 -815H1107C1108.1 -815 1109 -814.105 1109 -813V1383C1109 1384.1 1108.1 1385 1107 1385H-6018C-6019.1 1385 -6020 1384.1 -6020 1383V-813Z",
            fill: "#F1F2F4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M-6018 -814H1107V-816H-6018V-814ZM1108 -813V1383H1110V-813H1108ZM1107 1384H-6018V1386H1107V1384ZM-6019 1383V-813H-6021V1383H-6019ZM-6018 1384C-6018.55 1384 -6019 1383.55 -6019 1383H-6021C-6021 1384.66 -6019.66 1386 -6018 1386V1384ZM1108 1383C1108 1383.55 1107.55 1384 1107 1384V1386C1108.66 1386 1110 1384.66 1110 1383H1108ZM1107 -814C1107.55 -814 1108 -813.552 1108 -813H1110C1110 -814.657 1108.66 -816 1107 -816V-814ZM-6018 -816C-6019.66 -816 -6021 -814.657 -6021 -813H-6019C-6019 -813.552 -6018.55 -814 -6018 -814V-816Z",
            fill: "black",
            "fill-opacity": "0.1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            filter: "url(#filter0_d_134_51661)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "484",
            height: "536",
            transform: "translate(-59 -96)",
            fill: "#F1F2F4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "200",
            height: "244",
            transform: "matrix(0.997242 -0.0742187 0.0655601 0.997849 0 15.8682)",
            fill: "#1868DB"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "172.24",
            y: "13.9958",
            width: "193",
            height: "243",
            transform: "rotate(1.512 172.24 13.9958)",
            fill: "#FCA700"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M200.349 14.738L215.445 244.499L166.059 248.175L172.24 13.9961L200.349 14.738Z",
            fill: "#09326C"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "185",
            transform: "translate(41 40)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "56",
            transform: "translate(41 40)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip0_134_51661)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip1_134_51661)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip2_134_51661)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip3_134_51661)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M67.2752 72.3371H65.6108C63.1006 72.3371 61.2998 70.7996 61.2998 68.5482H70.2492C70.7131 68.5482 71.0132 68.8777 71.0132 69.3444V78.35C68.7758 78.35 67.2752 76.5379 67.2752 74.012V72.3371ZM71.6953 67.8618H70.0309C67.5207 67.8618 65.7199 66.3517 65.7199 64.1003H74.6694C75.1332 64.1003 75.4606 64.4023 75.4606 64.8691V73.8747C73.2233 73.8747 71.6953 72.0626 71.6953 69.5366V67.8618ZM76.1427 63.4139H74.4784C71.9682 63.4139 70.1674 61.8764 70.1674 59.625H79.1168C79.5806 59.625 79.8808 59.9545 79.8808 60.3938V69.3993C77.6434 69.3993 76.1427 67.5872 76.1427 65.0613V63.4139Z",
            fill: "#1868DB"
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#172B4D",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            "font-size": "16",
            fontWeight: "590",
            letterSpacing: "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "91",
            y: "73.6875"
        }, formatMessage((0, (0, parcelRequire("icj7A")).default).attachmentsSvgText1)))), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "62",
            y: "96",
            width: "242",
            height: "86",
            fill: "#F8F8F8",
            stroke: "#DDDEE1",
            "stroke-width": "2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "305.285",
            y: "131.444",
            width: "67.5",
            height: "67.5",
            transform: "rotate(9.40907 305.285 131.444)",
            fill: "#BF63F3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "311.837",
            y: "143.896",
            width: "51.5625",
            height: "48.4375",
            transform: "rotate(9.40907 311.837 143.896)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M364.461 147.322L310.509 138.381L301.568 192.333L355.52 201.274L364.461 147.322ZM332.684 159.874C331.979 164.131 327.956 167.01 323.7 166.304C319.443 165.599 316.564 161.576 317.269 157.32C317.975 153.063 321.997 150.184 326.254 150.889C330.511 151.595 333.389 155.617 332.684 159.874ZM343.607 165.644L312.161 188.149L350.697 194.535L353.252 179.12L343.607 165.644Z",
            fill: "#BF63F3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M288.264 112.961C288.597 116.147 288.316 119.659 289.538 122.594C291.972 118.595 297 113.622 300.141 111.264C302.478 110.106 303.709 108.481 306.195 107.934C306.195 107.934 305.818 107.83 305.806 107.829C313.408 103.44 324.594 99.817 333.578 100.05C333.552 100.07 333.516 100.084 333.553 100.112C332.711 100.263 328.729 100.994 328.723 100.993C331.916 101.688 335.151 100.45 338.368 100.689C337.8 99.9931 335.473 100.377 335.227 100.095C341.763 99.6704 348.768 100.828 354.757 103.56C354.411 103.595 353.176 102.789 352.742 103.318C353.598 103.544 357.241 105.296 355.477 104.01C365.128 106.9 375.181 114.37 381.665 122.403C383.204 124.372 383.438 125.099 381.455 123.646L381.45 123.98C379.311 121.545 376.408 120.164 375.314 117.573C372.666 117.971 368.557 111.403 365.421 110.821C365.95 112.387 358.128 105.649 358.927 107.588C345.481 102.752 328.613 100.106 315.535 107.065L315.584 106.942C305.634 109.293 297.483 115.729 290.995 123.678C292.689 123.441 295.357 122.435 296.32 123.085C306.381 121.169 291.511 127.127 287.883 126.087L287.915 126.067C287.915 126.067 287.084 125.968 287.119 126.072C285.924 124.044 285.334 112.204 288.266 112.949L288.264 112.961Z",
            fill: "#101214"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("filter", {
            id: "filter0_d_134_51661",
            x: "-63",
            y: "-96",
            width: "492",
            height: "544",
            filterUnits: "userSpaceOnUse",
            "color-interpolation-filters": "sRGB"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("feFlood", {
            "flood-opacity": "0",
            result: "BackgroundImageFix"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("feOffset", {
            dy: "4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("feGaussianBlur", {
            stdDeviation: "2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("feComposite", {
            in2: "hardAlpha",
            operator: "out"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_134_51661"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect1_dropShadow_134_51661",
            result: "shape"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_134_51661"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "236",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip1_134_51661"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip2_134_51661"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip3_134_51661"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "18.581",
            height: "18.725",
            fill: "white",
            transform: "translate(61.2998 59.625)"
        }))));
    }
});
parcelRegister("rp9KL", function(module, exports) {
    $parcel$export(module.exports, "AuditLogGraphic", ()=>$f90a7d762f0dafb3$export$d79650c60360b5a4);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $icj7A;
    function $f90a7d762f0dafb3$export$d79650c60360b5a4() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "387",
            height: "276",
            viewBox: "0 0 387 276",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "200",
            height: "244",
            transform: "matrix(0.997242 -0.0742187 0.0655601 0.997849 0 15.8682)",
            fill: "#1868DB"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "172.24",
            y: "13.9958",
            width: "193",
            height: "243",
            transform: "rotate(1.512 172.24 13.9958)",
            fill: "#FCA700"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M200.349 14.738L215.445 244.499L166.059 248.175L172.24 13.9961L200.349 14.738Z",
            fill: "#09326C"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "185",
            transform: "translate(41 40)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "56",
            transform: "translate(41 40)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip0_1210_17850)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip1_1210_17850)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip2_1210_17850)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip3_1210_17850)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M67.2752 72.3371H65.6108C63.1006 72.3371 61.2998 70.7996 61.2998 68.5482H70.2492C70.7131 68.5482 71.0132 68.8777 71.0132 69.3444V78.35C68.7758 78.35 67.2752 76.5379 67.2752 74.012V72.3371ZM71.6953 67.8618H70.0309C67.5207 67.8618 65.7199 66.3517 65.7199 64.1003H74.6694C75.1332 64.1003 75.4606 64.4023 75.4606 64.8691V73.8747C73.2233 73.8747 71.6953 72.0626 71.6953 69.5366V67.8618ZM76.1427 63.4139H74.4784C71.9682 63.4139 70.1674 61.8764 70.1674 59.625H79.1168C79.5806 59.625 79.8808 59.9545 79.8808 60.3938V69.3993C77.6434 69.3993 76.1427 67.5872 76.1427 65.0613V63.4139Z",
            fill: "#1868DB"
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#172B4D",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            "font-size": "16",
            fontWeight: "590",
            letterSpacing: "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "91",
            y: "73.6875"
        }, formatMessage((0, (0, parcelRequire("icj7A")).default).auditLogSvgText)))), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M172.823 102.883C171.712 103.725 170.323 104.114 168.937 103.971C167.551 103.829 166.27 103.165 165.354 102.115C164.439 101.064 163.956 99.7051 164.003 98.3123C164.051 96.9194 164.625 95.5966 165.611 94.6111C166.596 93.6256 167.919 93.051 169.312 93.0034C170.705 92.9558 172.064 93.4387 173.114 94.3546C174.165 95.2704 174.828 96.5509 174.971 97.9373C175.114 99.3236 174.725 100.712 173.883 101.823L176.53 104.47C176.823 104.763 177.06 105.06 176.53 105.53C176 106 175.763 105.823 175.47 105.53L172.823 102.883ZM169.5 102.5C170.561 102.5 171.578 102.079 172.328 101.328C173.078 100.578 173.5 99.5609 173.5 98.5C173.5 97.4391 173.078 96.4217 172.328 95.6716C171.578 94.9214 170.561 94.5 169.5 94.5C168.439 94.5 167.422 94.9214 166.671 95.6716C165.921 96.4217 165.5 97.4391 165.5 98.5C165.5 99.5609 165.921 100.578 166.671 101.328C167.422 102.079 168.439 102.5 169.5 102.5Z",
            fill: "#B7B9BE"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "135",
            y: "126",
            width: "52",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "60.5",
            y: "88.5",
            width: "121",
            height: "23",
            rx: "2.5",
            stroke: "#B3B9C4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "135",
            y: "150",
            width: "52",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "60",
            y: "150",
            width: "66",
            height: "9",
            rx: "3",
            fill: "#CFE1FD"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "60",
            y: "174",
            width: "66",
            height: "9",
            rx: "3",
            fill: "#CFE1FD"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "60",
            y: "198",
            width: "66",
            height: "9",
            rx: "3",
            fill: "#CFE1FD"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "135",
            y: "174",
            width: "52",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "135",
            y: "198",
            width: "52",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#626F86",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            "font-family": "SF Pro",
            "font-size": "10",
            "font-weight": "510",
            "letter-spacing": "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "60",
            y: "132.555"
        }, "May 24, 8am")), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "194",
            y: "126",
            width: "28",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "194",
            y: "150",
            width: "28",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "194",
            y: "174",
            width: "28",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "194",
            y: "198",
            width: "28",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "229",
            y: "126",
            width: "70",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "229",
            y: "150",
            width: "70",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "229",
            y: "174",
            width: "70",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "229",
            y: "198",
            width: "70",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_1210_17850"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "236",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip1_1210_17850"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip2_1210_17850"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip3_1210_17850"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "18.581",
            height: "18.725",
            fill: "white",
            transform: "translate(61.2998 59.625)"
        }))));
    }
});
parcelRegister("47JDo", function(module, exports) {
    $parcel$export(module.exports, "AutomationGraphic", ()=>$2c48702882583192$export$f4881dcde72d6d6d);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $icj7A;
    function $2c48702882583192$export$f4881dcde72d6d6d() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "366",
            height: "276",
            viewBox: "0 0 366 276",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "200",
            height: "244",
            transform: "matrix(0.997242 -0.0742187 0.0655601 0.997849 0 15.8682)",
            fill: "#1868DB"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "172.24",
            y: "13.9958",
            width: "193",
            height: "243",
            transform: "rotate(1.512 172.24 13.9958)",
            fill: "#FCA700"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M200.349 14.738L215.445 244.499L166.059 248.175L172.24 13.9961L200.349 14.738Z",
            fill: "#09326C"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "185",
            transform: "translate(41 40)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "56",
            transform: "translate(41 40)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip0_1210_18323)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip1_1210_18323)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip2_1210_18323)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip3_1210_18323)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M67.2752 72.3371H65.6108C63.1006 72.3371 61.2998 70.7996 61.2998 68.5482H70.2492C70.7131 68.5482 71.0132 68.8777 71.0132 69.3444V78.35C68.7758 78.35 67.2752 76.5379 67.2752 74.012V72.3371ZM71.6953 67.8618H70.0309C67.5207 67.8618 65.7199 66.3517 65.7199 64.1003H74.6694C75.1332 64.1003 75.4606 64.4023 75.4606 64.8691V73.8747C73.2233 73.8747 71.6953 72.0626 71.6953 69.5366V67.8618ZM76.1427 63.4139H74.4784C71.9682 63.4139 70.1674 61.8764 70.1674 59.625H79.1168C79.5806 59.625 79.8808 59.9545 79.8808 60.3938V69.3993C77.6434 69.3993 76.1427 67.5872 76.1427 65.0613V63.4139Z",
            fill: "#1868DB"
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#172B4D",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            fontSize: "16",
            fontWeight: "590",
            letterSpacing: "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "91",
            y: "73.6875"
        }, formatMessage((0, (0, parcelRequire("icj7A")).default).automationSvgText)))), (0, ($parcel$interopDefault($5uXOq))).createElement("line", {
            x1: "88.5",
            y1: "127",
            x2: "88.5",
            y2: "175",
            stroke: "#626F86"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "61.5",
            y: "95.5",
            width: "236",
            height: "31",
            rx: "9.5",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "61.5",
            y: "95.5",
            width: "236",
            height: "31",
            rx: "9.5",
            stroke: "#DCDFE4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#626F86",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            "font-family": "SF Pro",
            "font-size": "12",
            "font-weight": "510",
            "letter-spacing": "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "91",
            y: "115.266"
        }, "When:", ' ')), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "70",
            y: "103",
            width: "16",
            height: "16",
            rx: "3",
            fill: "#BAF3DB"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "132",
            y: "107",
            width: "112",
            height: "10",
            rx: "3",
            fill: "#DCDFE4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "61.5",
            y: "135.5",
            width: "236",
            height: "31",
            rx: "9.5",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "61.5",
            y: "135.5",
            width: "236",
            height: "31",
            rx: "9.5",
            stroke: "#DCDFE4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#626F86",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            "font-family": "SF Pro",
            "font-size": "12",
            "font-weight": "510",
            "letter-spacing": "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "91",
            y: "155.266"
        }, "Issue is:", ' ')), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "70",
            y: "143",
            width: "16",
            height: "16",
            rx: "3",
            fill: "#FFF7D6"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "145",
            y: "146",
            width: "69",
            height: "10",
            rx: "3",
            fill: "#DCDFE4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "61.5",
            y: "175.5",
            width: "236",
            height: "31",
            rx: "9.5",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "61.5",
            y: "175.5",
            width: "236",
            height: "31",
            rx: "9.5",
            stroke: "#DCDFE4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#626F86",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            "font-family": "SF Pro",
            "font-size": "12",
            "font-weight": "510",
            "letter-spacing": "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "91",
            y: "195.266"
        }, "Then:", ' ')), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "70",
            y: "184",
            width: "16",
            height: "16",
            rx: "3",
            fill: "#CCE0FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "130",
            y: "186",
            width: "137",
            height: "10",
            rx: "3",
            fill: "#DCDFE4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_1210_18323"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "236",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip1_1210_18323"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip2_1210_18323"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip3_1210_18323"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "18.581",
            height: "18.725",
            fill: "white",
            transform: "translate(61.2998 59.625)"
        }))));
    }
});
parcelRegister("1CzE7", function(module, exports) {
    $parcel$export(module.exports, "UserPermissionsGraphic", ()=>$c9dc0b1fa5de2bf6$export$e73c60f80e02d0c9);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $icj7A;
    function $c9dc0b1fa5de2bf6$export$e73c60f80e02d0c9() {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "366",
            height: "276",
            viewBox: "0 0 366 276",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "200",
            height: "244",
            transform: "matrix(0.997242 -0.0742187 0.0655601 0.997849 0 15.8682)",
            fill: "#1868DB"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "172.24",
            y: "13.9958",
            width: "193",
            height: "243",
            transform: "rotate(1.512 172.24 13.9958)",
            fill: "#FCA700"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M200.349 14.738L215.445 244.499L166.059 248.175L172.24 13.9961L200.349 14.738Z",
            fill: "#09326C"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "185",
            transform: "translate(41 40)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "284",
            height: "56",
            transform: "translate(41 40)",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip0_1210_15417)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip1_1210_15417)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip2_1210_15417)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            "clip-path": "url(#clip3_1210_15417)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M67.2752 72.3371H65.6108C63.1006 72.3371 61.2998 70.7996 61.2998 68.5482H70.2492C70.7131 68.5482 71.0132 68.8777 71.0132 69.3444V78.35C68.7758 78.35 67.2752 76.5379 67.2752 74.012V72.3371ZM71.6953 67.8618H70.0309C67.5207 67.8618 65.7199 66.3517 65.7199 64.1003H74.6694C75.1332 64.1003 75.4606 64.4023 75.4606 64.8691V73.8747C73.2233 73.8747 71.6953 72.0626 71.6953 69.5366V67.8618ZM76.1427 63.4139H74.4784C71.9682 63.4139 70.1674 61.8764 70.1674 59.625H79.1168C79.5806 59.625 79.8808 59.9545 79.8808 60.3938V69.3993C77.6434 69.3993 76.1427 67.5872 76.1427 65.0613V63.4139Z",
            fill: "#1868DB"
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#172B4D",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            "font-size": "16",
            fontWeight: "590",
            letterSpacing: "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "91",
            y: "73.6875"
        }, formatMessage((0, (0, parcelRequire("icj7A")).default).userPermissionsSvgText)))), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M172.823 102.883C171.712 103.725 170.323 104.114 168.937 103.971C167.551 103.829 166.27 103.165 165.354 102.115C164.439 101.064 163.956 99.7051 164.003 98.3123C164.051 96.9194 164.625 95.5966 165.611 94.6111C166.596 93.6256 167.919 93.051 169.312 93.0034C170.705 92.9558 172.064 93.4387 173.114 94.3546C174.165 95.2704 174.828 96.5509 174.971 97.9373C175.114 99.3236 174.725 100.712 173.883 101.823L176.53 104.47C176.823 104.763 177.06 105.06 176.53 105.53C176 106 175.763 105.823 175.47 105.53L172.823 102.883ZM169.5 102.5C170.561 102.5 171.578 102.079 172.328 101.328C173.078 100.578 173.5 99.5609 173.5 98.5C173.5 97.4391 173.078 96.4217 172.328 95.6716C171.578 94.9214 170.561 94.5 169.5 94.5C168.439 94.5 167.422 94.9214 166.671 95.6716C165.921 96.4217 165.5 97.4391 165.5 98.5C165.5 99.5609 165.921 100.578 166.671 101.328C167.422 102.079 168.439 102.5 169.5 102.5Z",
            fill: "#B7B9BE"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "60.5",
            y: "88.5",
            width: "121",
            height: "23",
            rx: "2.5",
            stroke: "#B3B9C4"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "60",
            y: "131",
            width: "18",
            height: "18",
            rx: "9",
            stroke: "white",
            "stroke-width": "2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "69",
            cy: "140",
            r: "8",
            fill: "url(#pattern0_1210_15417)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "83",
            y: "135",
            width: "75",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#626F86",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            "font-family": "SF Pro",
            "font-size": "10",
            "font-weight": "510",
            "letter-spacing": "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "190",
            y: "143.555"
        }, "Admin")), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "238",
            y: "135",
            width: "63",
            height: "6",
            rx: "3",
            fill: "#CFE1FD"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "60",
            y: "154",
            width: "18",
            height: "18",
            rx: "9",
            stroke: "white",
            "stroke-width": "2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "69",
            cy: "163",
            r: "8",
            fill: "url(#pattern1_1210_15417)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "83",
            y: "158",
            width: "94",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#626F86",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            "font-family": "SF Pro",
            "font-size": "10",
            "font-weight": "510",
            "letter-spacing": "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "190",
            y: "166.555"
        }, "Member")), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "238",
            y: "158",
            width: "63",
            height: "6",
            rx: "3",
            fill: "#CFE1FD"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "60",
            y: "177",
            width: "18",
            height: "18",
            rx: "9",
            stroke: "white",
            "stroke-width": "2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "69",
            cy: "186",
            r: "8",
            fill: "url(#pattern2_1210_15417)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "83",
            y: "181",
            width: "65",
            height: "9",
            rx: "3",
            fill: "#DDDEE1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("text", {
            fill: "#626F86",
            xmlSpace: "preserve",
            style: {
                whiteSpace: 'pre'
            },
            "font-family": "SF Pro",
            "font-size": "10",
            "font-weight": "510",
            "letter-spacing": "0px"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("tspan", {
            x: "190",
            y: "189.555"
        }, "Viewer")), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "238",
            y: "181",
            width: "63",
            height: "6",
            rx: "3",
            fill: "#CFE1FD"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("pattern", {
            id: "pattern0_1210_15417",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("use", {
            xlinkHref: "#image0_1210_15417",
            transform: "scale(0.0025)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("pattern", {
            id: "pattern1_1210_15417",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("use", {
            xlinkHref: "#image1_1210_15417",
            transform: "scale(0.0025)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("pattern", {
            id: "pattern2_1210_15417",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("use", {
            xlinkHref: "#image2_1210_15417",
            transform: "scale(0.0025)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_1210_15417"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "236",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip1_1210_15417"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip2_1210_15417"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            transform: "translate(59 56)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip3_1210_15417"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "18.581",
            height: "18.725",
            fill: "white",
            transform: "translate(61.2998 59.625)"
        }))));
    }
});
parcelRegister("g1ZdZ", function(module, exports) {
    $parcel$export(module.exports, "BenefitsListSection", ()=>$1abadfb912a630b1$export$50891c0e4b7fa982);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $eToDA;
    var $5EgpU;
    function $1abadfb912a630b1$export$50891c0e4b7fa982({ canPay: canPay }) {
        const benefitsListContent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("5EgpU")).getBenefitsListContent)(canPay), [
            canPay
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1abadfb912a630b1$var$BenefitsListSectionStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $1abadfb912a630b1$var$BenefitsBodyStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eToDA")).BenefitsList), {
            benefits: benefitsListContent || []
        })));
    }
    const $1abadfb912a630b1$var$BenefitsListSectionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxSizing: 'border-box',
        minHeight: '236px'
    });
    const $1abadfb912a630b1$var$BenefitsBodyStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexDirection: 'column',
        gap: 'space.250'
    });
});
parcelRegister("eToDA", function(module, exports) {
    $parcel$export(module.exports, "BenefitsList", ()=>$7fca06e81ec31cf8$export$ccb2870a847830f2);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $koVbs;
    function $7fca06e81ec31cf8$export$ccb2870a847830f2({ benefits: benefits }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("ul", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_qtt8glyw _19bvidpf"
            ])
        }, benefits.map((benefit, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: index,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_n3tdv47k _19pkidpf"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                xcss: $7fca06e81ec31cf8$var$ListItemStyles,
                key: benefit.description.id
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: [
                    $7fca06e81ec31cf8$var$IconStyles
                ]
            }, benefit.icon), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                weight: "bold"
            }, formatMessage(benefit.title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage(benefit.description)))))))));
    }
    const $7fca06e81ec31cf8$var$IconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.selected',
        borderRadius: 'border.radius.circle',
        display: 'flex',
        width: '24px',
        height: '24px',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: '0'
    });
    const $7fca06e81ec31cf8$var$BenefitsListStyles = null;
    const $7fca06e81ec31cf8$var$BenefitsListItemStyles = null;
    const $7fca06e81ec31cf8$var$ListItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignItems: 'center',
        gap: 'space.200'
    });
});
parcelRegister("5EgpU", function(module, exports) {
    $parcel$export(module.exports, "getBenefitsListContent", ()=>$f4632f5d17fd987c$export$315c3830bbc61e3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $61MPp;
    var $4Rw2J;
    var $ijaND;
    var $9leAG;
    var $hrfsZ;
    var $2KIxb;
    const $f4632f5d17fd987c$var$AutomationIcon = ({ label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            size: "medium",
            glyph: (0, (0, parcelRequire("hrfsZ")).AutomationGlyph),
            label: label,
            secondaryColor: "none"
        });
    const $f4632f5d17fd987c$var$jswEditionBenefits = new Map(Object.entries({
        canPay: [
            {
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ijaND"))))), {
                    size: "medium",
                    label: "People group icon"
                }),
                title: (0, (0, parcelRequire("2KIxb")).default).jswStandardUnlimitedUsersTitle,
                description: (0, (0, parcelRequire("2KIxb")).default).jswStandardUnlimitedUsersSubText
            },
            {
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4Rw2J"))))), {
                    size: "medium",
                    label: "File icon"
                }),
                title: (0, (0, parcelRequire("2KIxb")).default).jswStandardAuditLogTitle,
                description: (0, (0, parcelRequire("2KIxb")).default).jswStandardAuditLogSubText
            },
            {
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement($f4632f5d17fd987c$var$AutomationIcon, {
                    label: "Automation icon"
                }),
                title: (0, (0, parcelRequire("2KIxb")).default).jswStandardAutomationsTitle,
                description: (0, (0, parcelRequire("2KIxb")).default).jswStandardAutomationsSubText
            },
            {
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9leAG"))))), {
                    size: "medium",
                    label: "Unlock filled icon"
                }),
                title: (0, (0, parcelRequire("2KIxb")).default).jswStandardIssuePermissionsTitle,
                description: (0, (0, parcelRequire("2KIxb")).default).jswStandardIssuePermissionsSubText
            }
        ],
        notPay: [
            {
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ijaND"))))), {
                    size: "medium",
                    label: "People group icon"
                }),
                title: (0, (0, parcelRequire("2KIxb")).default).jswStandardUnlimitedUsersTitle,
                description: (0, (0, parcelRequire("2KIxb")).default).jswStandardUnlimitedUsersSubText
            },
            {
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("61MPp"))))), {
                    size: "medium",
                    label: "Export icon"
                }),
                title: (0, (0, parcelRequire("2KIxb")).default).jswStandardStorageTitle,
                description: (0, (0, parcelRequire("2KIxb")).default).jswStandardStorageSubText
            },
            {
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement($f4632f5d17fd987c$var$AutomationIcon, {
                    label: "Automation icon"
                }),
                title: (0, (0, parcelRequire("2KIxb")).default).jswStandardAutomationsTitle,
                description: (0, (0, parcelRequire("2KIxb")).default).jswStandardAutomationsSubText
            }
        ]
    }));
    const $f4632f5d17fd987c$export$315c3830bbc61e3c = (canPay)=>canPay ? $f4632f5d17fd987c$var$jswEditionBenefits.get('canPay') : $f4632f5d17fd987c$var$jswEditionBenefits.get('notPay');
});
parcelRegister("61MPp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4638b6534bbbec0b$var$_react = $4638b6534bbbec0b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4638b6534bbbec0b$var$_upload = $4638b6534bbbec0b$var$_interopRequireDefault((parcelRequire("50qBU")));
    function $4638b6534bbbec0b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4638b6534bbbec0b$var$ExportIcon = (props)=>$4638b6534bbbec0b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
        }, props, {
            newIcon: $4638b6534bbbec0b$var$_upload.default
        }));
    $4638b6534bbbec0b$var$ExportIcon.displayName = 'ExportIcon';
    var $4638b6534bbbec0b$var$_default = module.exports.default = $4638b6534bbbec0b$var$ExportIcon;
});
parcelRegister("50qBU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3a519821f4edd432$var$_react = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3a519821f4edd432$var$_UNSAFE_baseNew = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3a519821f4edd432$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3a519821f4edd432$var$UploadIcon = (props)=>$3a519821f4edd432$var$_react.default.createElement($3a519821f4edd432$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
        }, props));
    $3a519821f4edd432$var$UploadIcon.displayName = 'UploadIcon';
    var $3a519821f4edd432$var$_default = module.exports.default = $3a519821f4edd432$var$UploadIcon;
});
parcelRegister("4Rw2J", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $38a4f7c4ef65cc10$var$_react = $38a4f7c4ef65cc10$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $38a4f7c4ef65cc10$var$_file = $38a4f7c4ef65cc10$var$_interopRequireDefault((parcelRequire("1NlXW")));
    function $38a4f7c4ef65cc10$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $38a4f7c4ef65cc10$var$FileIcon = (props)=>$38a4f7c4ef65cc10$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/><rect width="8" height="2" x="8" y="12" rx="1"/><rect width="4" height="2" x="8" y="15" rx="1"/></g></svg>`
        }, props, {
            newIcon: $38a4f7c4ef65cc10$var$_file.default
        }));
    $38a4f7c4ef65cc10$var$FileIcon.displayName = 'FileIcon';
    var $38a4f7c4ef65cc10$var$_default = module.exports.default = $38a4f7c4ef65cc10$var$FileIcon;
});
parcelRegister("1NlXW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $14eb6801df53e470$var$_react = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $14eb6801df53e470$var$_UNSAFE_baseNew = $14eb6801df53e470$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $14eb6801df53e470$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $14eb6801df53e470$var$FileIcon = (props)=>$14eb6801df53e470$var$_react.default.createElement($14eb6801df53e470$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 5.25V14c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25V2c0-.69.56-1.25 1.25-1.25h4.75m4.5 4.5h-4.5V.75m4.5 4.5c0-.32-.127-.627-.354-.854L9.604 1.104A1.2 1.2 0 0 0 8.75.75"/>`
        }, props));
    $14eb6801df53e470$var$FileIcon.displayName = 'FileIcon';
    var $14eb6801df53e470$var$_default = module.exports.default = $14eb6801df53e470$var$FileIcon;
});
parcelRegister("ijaND", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d54260e58fec7f9a$var$_react = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d54260e58fec7f9a$var$_personAdd = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("fvfvk")));
    function $d54260e58fec7f9a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d54260e58fec7f9a$var$InviteTeamIcon = (props)=>$d54260e58fec7f9a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
        }, props, {
            newIcon: $d54260e58fec7f9a$var$_personAdd.default
        }));
    $d54260e58fec7f9a$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
    var $d54260e58fec7f9a$var$_default = module.exports.default = $d54260e58fec7f9a$var$InviteTeamIcon;
});
parcelRegister("fvfvk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b495c71cb30b2c7c$var$_react = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b495c71cb30b2c7c$var$_UNSAFE_baseNew = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $b495c71cb30b2c7c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b495c71cb30b2c7c$var$PersonAddIcon = (props)=>$b495c71cb30b2c7c$var$_react.default.createElement($b495c71cb30b2c7c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15M13 8V5m0 3v3m0-3h3m-3 0h-3M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
        }, props));
    $b495c71cb30b2c7c$var$PersonAddIcon.displayName = 'PersonAddIcon';
    var $b495c71cb30b2c7c$var$_default = module.exports.default = $b495c71cb30b2c7c$var$PersonAddIcon;
});
parcelRegister("9leAG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6cd1649e81d79beb$var$_react = $6cd1649e81d79beb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6cd1649e81d79beb$var$_lockUnlocked = $6cd1649e81d79beb$var$_interopRequireDefault((parcelRequire("jHgVl")));
    function $6cd1649e81d79beb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6cd1649e81d79beb$var$UnlockFilledIcon = (props)=>$6cd1649e81d79beb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 11.009C5 9.899 5.897 9 7.006 9h9.988A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991zM12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/><path fill-rule="nonzero" d="M8 6.251v-.249A4.004 4.004 0 0 1 12 2a4 4 0 0 1 4 4.002V6.5h-2v-.498A2 2 0 0 0 12 4c-1.102 0-2 .898-2 2.002V11H8zm6 .249h2a1 1 0 0 1-2 0"/></g></svg>`
        }, props, {
            newIcon: $6cd1649e81d79beb$var$_lockUnlocked.default
        }));
    $6cd1649e81d79beb$var$UnlockFilledIcon.displayName = 'UnlockFilledIcon';
    var $6cd1649e81d79beb$var$_default = module.exports.default = $6cd1649e81d79beb$var$UnlockFilledIcon;
});
parcelRegister("jHgVl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e56f2934baaafa03$var$_react = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e56f2934baaafa03$var$_UNSAFE_baseNew = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e56f2934baaafa03$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e56f2934baaafa03$var$LockUnlockedIcon = (props)=>$e56f2934baaafa03$var$_react.default.createElement($e56f2934baaafa03$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.25 4a3.25 3.25 0 1 0-6.5 0v3.75m0 0H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25z"/>`
        }, props));
    $e56f2934baaafa03$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
    var $e56f2934baaafa03$var$_default = module.exports.default = $e56f2934baaafa03$var$LockUnlockedIcon;
});
parcelRegister("hrfsZ", function(module, exports) {
    $parcel$export(module.exports, "AutomationGlyph", ()=>$7a6859ebc905c49b$export$3b6023946faff8bc);
    var $5uXOq = parcelRequire("5uXOq");
    const $7a6859ebc905c49b$export$3b6023946faff8bc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L7 12H17L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }));
});
parcelRegister("2KIxb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$962fa18790c97e51$export$2e2bcd8739ae039);
    var $7VHMR;
    var $962fa18790c97e51$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        jswStandardUnlimitedUsersTitle: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-unlimited-users-title",
            "defaultMessage": "Unlimited users"
        },
        jswStandardUnlimitedUsersSubText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-unlimited-users-sub-text",
            "defaultMessage": "Get your entire team in one tool"
        },
        jswStandardAuditLogTitle: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-audit-log-title",
            "defaultMessage": "Audit log"
        },
        jswStandardAuditLogSubText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-audit-log-sub-text",
            "defaultMessage": "Review and troubleshoot site changes"
        },
        jswStandardAutomationsTitle: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-automations-title",
            "defaultMessage": "1,700 automation runs"
        },
        jswStandardAutomationsSubText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-automations-sub-text",
            "defaultMessage": "Save time by automating routine tasks"
        },
        jswStandardIssuePermissionsTitle: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-issue-permissions-title",
            "defaultMessage": "Issue permissions "
        },
        jswStandardIssuePermissionsSubText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-issue-permissions-sub-text",
            "defaultMessage": "Decide who can view, comment, and create"
        },
        jswStandardStorageTitle: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-storage-title",
            "defaultMessage": "250 GB of storage"
        },
        jswStandardStorageSubText: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-storage-sub-text",
            "defaultMessage": "Upload files without running out of space"
        },
        jswStandardCarouslSlideUserLimit: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-user-limit",
            "defaultMessage": "Unlimited People"
        },
        jswStandardCarouslSlideAuditLog: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-audit-log",
            "defaultMessage": "Audit Log"
        },
        jswStandardCarouslSlideUserAutomation: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-user-automation",
            "defaultMessage": "Automation"
        },
        jswStandardCarouslSlideUserPermissions: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-user-permissions",
            "defaultMessage": "User permissions"
        },
        jswStandardCarouslSlideStorageLimit: {
            "id": "loss-aversion.loss-aversion-modal.split-panel.benefits-list-section.jsw-standard-carousl-slide-storage-limit",
            "defaultMessage": "Storage limit"
        }
    });
});
parcelRegister("6ERtZ", function(module, exports) {
    $parcel$export(module.exports, "StorageModal", ()=>$df991be868bdf516$export$de0de9a0c528fc33);
    var $5uXOq = parcelRequire("5uXOq");
    var $2gQ83;
    var $eCeGD;
    var $1GGwS;
    var $dC5iT;
    var $8CUq3;
    var $gOC1a;
    var $8awgF;
    var $39xOx;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $2NMNM;
    var $frhEJ;
    var $9o6tH;
    var $d2jVW;
    var $b8CCP = parcelRequire("b8CCP");
    var $4KDd4;
    const $df991be868bdf516$export$de0de9a0c528fc33 = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl, storageUsedInGB: storageUsedInGB })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "storageModal",
            packageName: "jiraLossAversion",
            teamName: "luna-growth",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($df991be868bdf516$export$a6bf7c84b3543a58, {
            userCanPay: userCanPay,
            upgradeUrl: upgradeUrl,
            storageUsedInGB: storageUsedInGB
        }));
    const $df991be868bdf516$export$a6bf7c84b3543a58 = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl, storageUsedInGB: storageUsedInGB })=>{
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        const { isUrgent: isUrgent } = (0, (0, parcelRequire("9o6tH")).useExperimentEligibility)((0, $c173c7124ea4b2f6$export$855e843fe464d553), false);
        const { trialEndTime: trialEndTime } = (0, (0, parcelRequire("d2jVW")).useTrialDetails)();
        const origin = new (0, (0, parcelRequire("2gQ83")).default)({
            product: 'jira'
        });
        const addPaymentDetailsUrl = origin.addToUrl(upgradeUrl);
        const [showModal, setShowModal] = (0, $5uXOq.useState)(true);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const trialEndDate = trialEndTime && formatDate(new Date(trialEndTime), {
            day: 'numeric',
            month: 'long'
        });
        const onClose = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("frhEJ")).fireButtonAnalytics)(createAnalyticsEvent, 'jlaCloseButton', {
                userCanPay: userCanPay,
                upgradeUrl: upgradeUrl,
                storageUsedInGB: storageUsedInGB,
                trialEndTime: trialEndTime,
                modal: 'jlaStorage'
            });
            setShowModal(false);
        }, [
            createAnalyticsEvent,
            storageUsedInGB,
            trialEndTime,
            upgradeUrl,
            userCanPay
        ]);
        const onAddPaymentDetails = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("frhEJ")).fireButtonAnalytics)(createAnalyticsEvent, 'jlaAddPaymentButton', {
                userCanPay: userCanPay,
                upgradeUrl: upgradeUrl,
                storageUsedInGB: storageUsedInGB,
                trialEndTime: trialEndTime,
                modal: 'jlaStorage'
            });
            setShowModal(false);
        }, [
            createAnalyticsEvent,
            storageUsedInGB,
            trialEndTime,
            upgradeUrl,
            userCanPay
        ]);
        if (!showModal || !trialEndDate) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "jiraLossAversionStorage"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gOC1a")).Modal), {
            width: 488,
            title: formatMessage(isUrgent ? (0, (0, parcelRequire("4KDd4")).default).urgentHeading : (0, (0, parcelRequire("4KDd4")).default).nonUrgentHeading),
            subtitle: formatMessage(userCanPay ? (0, (0, parcelRequire("4KDd4")).default).adminSubheading : (0, (0, parcelRequire("4KDd4")).default).nonAdminSubheading, {
                formattedDate: trialEndDate
            }),
            onClose: onClose,
            testId: "loss-aversion.ui.loss-aversion-modal.storage",
            actions: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                onClick: onClose,
                appearance: "subtle"
            }, formatMessage(userCanPay ? (0, (0, parcelRequire("4KDd4")).default).maybeLater : (0, (0, parcelRequire("4KDd4")).default).close)), userCanPay && addPaymentDetailsUrl && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1GGwS")).default), {
                onClick: onAddPaymentDetails,
                href: addPaymentDetailsUrl,
                appearance: "primary",
                target: "_blank"
            }, formatMessage((0, (0, parcelRequire("4KDd4")).default).addPayment)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $df991be868bdf516$var$backgroundStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $df991be868bdf516$var$boxStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8awgF")).StorageLimits), {
            title: formatMessage((0, (0, parcelRequire("4KDd4")).default).usedStorageHeading, {
                storageUsed: storageUsedInGB.toFixed(0)
            }),
            description: formatMessage((0, (0, parcelRequire("4KDd4")).default).usedStorageSubheading),
            ariaLabel: `${storageUsedInGB.toFixed(0)} GB of 250 GB (over free limit of 2 GB)`,
            used: Math.max(15, storageUsedInGB),
            limit: 250,
            baseLimit: {
                title: 'Free limit',
                limit: 2
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($b8CCP))),
            style: {
                marginTop: '36px'
            },
            alt: "",
            height: 46,
            width: 67
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                experiment: (0, $c173c7124ea4b2f6$export$855e843fe464d553)
            }
        }));
    };
    const $df991be868bdf516$var$backgroundStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '388px',
        display: 'flex',
        backgroundColor: 'color.background.accent.blue.subtlest',
        borderRadius: '4.2px'
    });
    const $df991be868bdf516$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '310px',
        paddingTop: 'space.300',
        paddingLeft: 'space.300',
        paddingRight: 'space.100',
        paddingBottom: 'space.600'
    });
});
parcelRegister("8awgF", function(module, exports) {
    $parcel$export(module.exports, "StorageLimits", ()=>$d4d1a2e9755cb44f$export$ca644461e233232);
    var $5uXOq = parcelRequire("5uXOq");
    var $1dJ6S;
    var $lfdem;
    var $luBm6;
    var $cgL5K;
    var $berBo;
    const $d4d1a2e9755cb44f$export$ca644461e233232 = ({ title: title, description: description, used: used, limit: limit, ariaLabel: ariaLabel, baseLimit: baseLimit })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfdem")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "small"
        }, title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            color: "color.text.subtlest"
        }, description)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("berBo")).ProgressBar), {
            value: used / limit,
            ariaLabel: ariaLabel,
            baseLimit: baseLimit,
            limit: limit
        })));
    };
});
parcelRegister("berBo", function(module, exports) {
    $parcel$export(module.exports, "ProgressBar", ()=>$cbda0c7985028ed0$export$c17561cb55d4db30);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    const $cbda0c7985028ed0$var$MIN_VALUE = 0;
    const $cbda0c7985028ed0$var$MAX_VALUE = 1;
    const $cbda0c7985028ed0$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '12px',
        width: '100%',
        borderRadius: 'border.radius.circle',
        position: 'relative'
    });
    const $cbda0c7985028ed0$var$barStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '12px',
        height: '12px',
        borderRadius: 'border.radius.circle'
    });
    const $cbda0c7985028ed0$var$baseBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '12px',
        height: '12px',
        borderTopLeftRadius: 'border.radius.circle',
        borderBottomLeftRadius: 'border.radius.circle',
        backgroundColor: 'color.background.accent.purple.subtle',
        position: 'absolute',
        top: 'space.0',
        left: 'space.0',
        borderRightWidth: 'border.width.outline',
        borderRightStyle: 'solid',
        borderRightColor: 'color.border.inverse'
    });
    const $cbda0c7985028ed0$var$baseTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        minWidth: '12px',
        marginLeft: 'space.150',
        position: 'relative',
        '::after': {
            borderLeftWidth: 'border.width.outline',
            borderLeftStyle: 'dotted',
            borderLeftColor: 'color.border.discovery',
            position: 'absolute',
            top: '0',
            left: '-2px',
            content: '""',
            display: 'block',
            width: '1px',
            height: '16px'
        }
    });
    const $cbda0c7985028ed0$export$c17561cb55d4db30 = ({ value: value, ariaLabel: ariaLabel, baseLimit: baseLimit, limit: limit })=>{
        const amount = Math.max($cbda0c7985028ed0$var$MIN_VALUE, Math.min(value, $cbda0c7985028ed0$var$MAX_VALUE));
        const backgroundColor = (0, $5uXOq.useMemo)(()=>{
            if (baseLimit !== undefined) return 'color.background.accent.blue.bolder';
            if (amount >= 0.9) return 'color.background.danger.bold';
            if (amount >= 0.7) return 'color.background.warning.bold';
            return 'color.background.accent.blue.bolder';
        }, [
            amount,
            baseLimit
        ]);
        if (baseLimit !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            backgroundColor: 'color.background.input',
            xcss: $cbda0c7985028ed0$var$containerStyles,
            role: "progressbar",
            "aria-label": ariaLabel,
            "aria-valuemin": $cbda0c7985028ed0$var$MIN_VALUE,
            "aria-valuenow": amount,
            "aria-valuemax": $cbda0c7985028ed0$var$MAX_VALUE
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            backgroundColor: backgroundColor,
            style: {
                width: `${Number(amount) * 100}%`
            },
            xcss: $cbda0c7985028ed0$var$barStyles
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            style: {
                width: `${Number(baseLimit.limit / limit) * 100}%`
            },
            xcss: $cbda0c7985028ed0$var$baseBarStyles
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            style: {
                paddingLeft: `${Number(baseLimit.limit / limit) * 100}%`
            },
            xcss: $cbda0c7985028ed0$var$baseTextStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            weight: "medium",
            color: "color.text.discovery"
        }, baseLimit.title))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            backgroundColor: 'color.background.accent.gray.subtlest',
            xcss: $cbda0c7985028ed0$var$containerStyles,
            role: "progressbar",
            "aria-label": ariaLabel,
            "aria-valuemin": $cbda0c7985028ed0$var$MIN_VALUE,
            "aria-valuenow": amount,
            "aria-valuemax": $cbda0c7985028ed0$var$MAX_VALUE
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            backgroundColor: backgroundColor,
            style: {
                width: `${Number(amount) * 100}%`
            },
            xcss: $cbda0c7985028ed0$var$barStyles
        }));
    };
});
parcelRegister("b8CCP", function(module, exports) {
    module.exports = new URL("storage_stars.09afa2c3.svg", import.meta.url).toString();
});
parcelRegister("4KDd4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01572353d8b934ee$export$2e2bcd8739ae039);
    var $7VHMR;
    var $01572353d8b934ee$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        urgentHeading: {
            "id": "loss-aversion.loss-aversion-modal.storage.urgent-heading",
            "defaultMessage": "Don\u2019t lose access to extra storage "
        },
        nonUrgentHeading: {
            "id": "loss-aversion.loss-aversion-modal.storage.non-urgent-heading",
            "defaultMessage": "Keep using 250 GB of storage"
        },
        adminSubheading: {
            "id": "loss-aversion.loss-aversion-modal.storage.admin-subheading",
            "defaultMessage": "Your Standard trial ends on {formattedDate}. Add payment to keep uploading files and images."
        },
        nonAdminSubheading: {
            "id": "loss-aversion.loss-aversion-modal.storage.non-admin-subheading",
            "defaultMessage": "Ask your admin to purchase Jira Standard for your team. Your trial ends on {formattedDate}."
        },
        addPayment: {
            "id": "loss-aversion.loss-aversion-modal.storage.add-payment",
            "defaultMessage": "Add payment"
        },
        maybeLater: {
            "id": "loss-aversion.loss-aversion-modal.storage.maybe-later",
            "defaultMessage": "Maybe later"
        },
        close: {
            "id": "loss-aversion.loss-aversion-modal.storage.close",
            "defaultMessage": "Close"
        },
        usedStorageHeading: {
            "id": "loss-aversion.loss-aversion-modal.storage.used-storage-heading",
            "defaultMessage": "{storageUsed} out of 250 GB used"
        },
        usedStorageSubheading: {
            "id": "loss-aversion.loss-aversion-modal.storage.used-storage-subheading",
            "defaultMessage": "Your team is over the Free plan\u2019s limit of 2 GB"
        }
    });
});
parcelRegister("hfMui", function(module, exports) {
    $parcel$export(module.exports, "UserLimitModal", ()=>$7ddfb4645b240b6a$export$c6f94866be4fd825);
    var $eeg8Q;
    var $5uXOq = parcelRequire("5uXOq");
    var $2gQ83;
    var $8Uumt = parcelRequire("8Uumt");
    var $2NMNM;
    var $eCeGD;
    var $1GGwS;
    var $jhmo0;
    var $dC5iT;
    var $8CUq3;
    var $gOC1a;
    var $lRmia;
    var $39xOx;
    var $jcw0u;
    var $eusud;
    var $ousew;
    var $koVbs;
    var $iXVV6;
    var $8zOmE;
    var $5oFIy;
    var $koeKL;
    var $frhEJ;
    var $9o6tH;
    var $d2jVW;
    var $e4uOc = parcelRequire("e4uOc");
    var $3IBj4;
    const $7ddfb4645b240b6a$export$c6f94866be4fd825 = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl, userCount: userCount })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "userLimitModal",
            packageName: "jiraLossAversion",
            teamName: "luna-growth",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7ddfb4645b240b6a$export$ec23fbe1e263ce95, {
            userCount: userCount,
            userCanPay: userCanPay,
            upgradeUrl: upgradeUrl
        }));
    const $7ddfb4645b240b6a$export$ec23fbe1e263ce95 = ({ userCanPay: userCanPay, upgradeUrl: upgradeUrl, userCount: userCount })=>{
        const [showModal, setShowModal] = (0, $5uXOq.useState)(true);
        const { isUrgent: isUrgent } = (0, (0, parcelRequire("9o6tH")).useExperimentEligibility)((0, $c173c7124ea4b2f6$export$855e843fe464d553), false);
        const onClose = ()=>setShowModal(false);
        const { trialEndTime: trialEndTime, trialDaysLeft: trialDaysLeft } = (0, (0, parcelRequire("d2jVW")).useTrialDetails)();
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        const [userAvatars, setUserAvatars] = (0, $5uXOq.useState)();
        const [loadingAvatars, setLoadingAvatars] = (0, $5uXOq.useState)(true);
        const [avatarsError, setAvatarsError] = (0, $5uXOq.useState)(null);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const trialEndDate = trialEndTime && formatDate(new Date(trialEndTime), {
            day: 'numeric',
            month: 'long'
        });
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const origin = new (0, (0, parcelRequire("2gQ83")).default)({
            product: 'jira'
        });
        const addPaymentDetailsUrl = origin.addToUrl(upgradeUrl);
        const REMOVE_USERS_LINK = '/admin/users?referrerName=JIRA';
        const data = (0, $8Uumt.useLazyLoadQuery)((0, (0, parcelRequire("eeg8Q")).default), {
            cloudId: cloudId
        });
        const projectKeys = (0, $5uXOq.useMemo)(()=>data?.jira?.allJiraProjects?.edges?.map((edge)=>edge?.node?.key) || [], [
            data
        ]);
        const onAddPaymentDetails = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("frhEJ")).fireButtonAnalytics)(createAnalyticsEvent, 'jlaAddPaymentButton', {
                trialDaysLeft: trialDaysLeft,
                userCanPay: userCanPay,
                modal: 'jlaUserModal'
            });
            setShowModal(false);
        }, [
            createAnalyticsEvent,
            trialDaysLeft,
            userCanPay
        ]);
        const onRemoveUsers = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("frhEJ")).fireButtonAnalytics)(createAnalyticsEvent, 'jlaRemoveUsers', {
                trialDaysLeft: trialDaysLeft,
                userCanPay: userCanPay,
                modal: 'jlaUserModal'
            });
        }, [
            createAnalyticsEvent,
            trialDaysLeft,
            userCanPay
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const fetchData = async ()=>{
                try {
                    const usersResponse = await (0, (0, parcelRequire("eusud")).performGetRequestWithRetry)(`/rest/api/3/user/assignable/multiProjectSearch?projectKeys=${projectKeys.join(',')}&maxResults=100`);
                    const userData = usersResponse?.map((user)=>({
                            key: user.emailAddress || '',
                            name: user.displayName || '',
                            src: user.avatarUrls['48x48']
                        }));
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetched userAvatars', {});
                    setUserAvatars(userData);
                    setShowModal(true);
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: error,
                        meta: {
                            id: 'fetchUserAvatarsWithRetry',
                            packageName: 'jiraLossAversion'
                        }
                    });
                    setAvatarsError(error.message || 'Unknown avatar fetch error');
                } finally{
                    setLoadingAvatars(false);
                }
            };
            fetchData();
        }, [
            projectKeys,
            createAnalyticsEvent,
            trialDaysLeft,
            userCanPay
        ]);
        const getSubTitleText = (0, $5uXOq.useCallback)(()=>{
            if (userCanPay) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...isUrgent ? (0, (0, parcelRequire("3IBj4")).default).jswStandardUserModalSubTitleUrgent : (0, (0, parcelRequire("3IBj4")).default).jswStandardUserModalSubTitle,
                values: {
                    a: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
                            href: REMOVE_USERS_LINK,
                            onClick: onRemoveUsers,
                            target: "_blank"
                        }, chunks),
                    trialEndDate: trialEndDate
                }
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...isUrgent ? (0, (0, parcelRequire("3IBj4")).default).jswStandardUserModalSubTitleNoPayUrgent : (0, (0, parcelRequire("3IBj4")).default).jswStandardUserModalSubTitleNoPay,
                values: {
                    trialEndDate: trialEndDate
                }
            });
        }, [
            isUrgent,
            trialEndDate,
            userCanPay,
            onRemoveUsers
        ]);
        const getTitleText = (0, $5uXOq.useCallback)(()=>{
            if (isUrgent) return formatMessage((0, (0, parcelRequire("3IBj4")).default).jswStandardUserModalTitleUrgent);
            if (userCanPay) return formatMessage((0, (0, parcelRequire("3IBj4")).default).jswStandardUserModalTitle);
            return formatMessage((0, (0, parcelRequire("3IBj4")).default).jswStandardUserModalTitleNoPay);
        }, [
            formatMessage,
            isUrgent,
            userCanPay
        ]);
        if (!showModal) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $7ddfb4645b240b6a$var$modalStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "jiraLossAversionUser"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gOC1a")).Modal), {
            width: 488,
            title: getTitleText(),
            subtitle: getSubTitleText(),
            onClose: onClose,
            testId: "loss-aversion.ui.loss-aversion-modal.user-limit",
            actions: userCanPay && addPaymentDetailsUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                onClick: onClose,
                appearance: "subtle"
            }, formatMessage((0, (0, parcelRequire("3IBj4")).default).jswStandardSecondaryCtaText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1GGwS")).default), {
                onClick: onAddPaymentDetails,
                appearance: "primary",
                href: addPaymentDetailsUrl,
                target: "_blank"
            }, formatMessage((0, (0, parcelRequire("3IBj4")).default).jswStandardPrimaryCtaText))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                onClick: onClose,
                appearance: "subtle"
            }, formatMessage((0, (0, parcelRequire("3IBj4")).default).jswStandardPrimaryCtaTextNoPay))
        }, !loadingAvatars && !avatarsError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $7ddfb4645b240b6a$var$userAvatarStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lRmia")).UserLimits), {
            dividerLimit: 10,
            assignedUsers: userAvatars || userCount,
            limit: 10,
            title: formatMessage((0, (0, parcelRequire("3IBj4")).default).jswStandardUserAvatarTitle, {
                userCount: userCount
            }),
            description: formatMessage((0, (0, parcelRequire("3IBj4")).default).jswStandardUserAvatarSubTitle)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($e4uOc))),
            style: {
                position: 'absolute',
                marginLeft: '275px',
                marginTop: '-20px'
            },
            alt: "",
            height: 54,
            width: 105
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                experiment: (0, $c173c7124ea4b2f6$export$855e843fe464d553),
                trialDaysLeft: trialDaysLeft,
                userCanPay: userCanPay
            }
        })));
    };
    const $7ddfb4645b240b6a$var$userAvatarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        padding: 'space.300',
        maxWidth: '400px',
        flexDirection: 'column',
        borderRadius: '4.2px',
        gap: 'space.150',
        backgroundColor: 'color.background.accent.blue.subtlest'
    });
    const $7ddfb4645b240b6a$var$modalStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        maxWidth: '499px',
        gap: 'space.0',
        flex: '1 0 0'
    });
});
parcelRegister("eeg8Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7e83da281c4704e$export$2e2bcd8739ae039);
    const $c7e83da281c4704e$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Literal",
                "name": "filter",
                "value": {
                    "sortBy": {
                        "order": "ASC",
                        "sortBy": "KEY"
                    },
                    "types": "SOFTWARE"
                }
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 100
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "key"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "userLimitModalQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjects",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "userLimitModalQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjects",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "f01d2dcbf15026d7e29e8dee47801496827b165db2e83daea189e41c6bab8c1a",
                "metadata": {},
                "name": "userLimitModalQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $c7e83da281c4704e$var$node.hash = "bbcd803edbb82700dc92e521570b35eb";
    var $c7e83da281c4704e$export$2e2bcd8739ae039 = $c7e83da281c4704e$var$node;
});
parcelRegister("lRmia", function(module, exports) {
    $parcel$export(module.exports, "UserLimits", ()=>$0adc97e9cdd80cf0$export$4954b8bb56ebcd48);
    var $5uXOq = parcelRequire("5uXOq");
    var $jnhNB;
    var $1dJ6S;
    var $5qRwM;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $hxoiH;
    var $jSXYd = parcelRequire("jSXYd");
    var $bno7S = parcelRequire("bno7S");
    var $2xRzL = parcelRequire("2xRzL");
    var $2hg0p = parcelRequire("2hg0p");
    var $dvgRl = parcelRequire("dvgRl");
    const $0adc97e9cdd80cf0$var$EMPTY_AVATAR = {
        key: '',
        name: ''
    };
    const $0adc97e9cdd80cf0$var$dividerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.150',
        marginLeft: 'space.075',
        height: 'space.500'
    });
    const $0adc97e9cdd80cf0$export$4954b8bb56ebcd48 = ({ title: title, description: description, assignedUsers: assignedUsers, limit: limit, size: size, dividerLimit: dividerLimit })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const avatars = (0, $5uXOq.useMemo)(()=>{
            const usedAvatarSrc = colorMode === 'dark' ? (0, ($parcel$interopDefault($jSXYd))) : (0, ($parcel$interopDefault($bno7S)));
            const unusedAvatarSrc = colorMode === 'dark' ? (0, ($parcel$interopDefault($2hg0p))) : (0, ($parcel$interopDefault($dvgRl)));
            const usedAvatar = {
                ...$0adc97e9cdd80cf0$var$EMPTY_AVATAR,
                src: usedAvatarSrc
            };
            const unusedAvatar = {
                ...$0adc97e9cdd80cf0$var$EMPTY_AVATAR,
                src: unusedAvatarSrc
            };
            if (!Array.isArray(assignedUsers)) {
                const usedAvatars = new Array(assignedUsers).fill(usedAvatar);
                const unusedAvatars = limit && limit - assignedUsers > 0 ? new Array(limit - assignedUsers).fill(unusedAvatar) : [];
                return [
                    ...usedAvatars,
                    ...unusedAvatars
                ];
            }
            if (limit === undefined || assignedUsers.length >= limit) return assignedUsers;
            const dummyAvatars = new Array(limit - assignedUsers.length).fill(unusedAvatar);
            return [
                ...assignedUsers,
                ...dummyAvatars
            ];
        }, [
            assignedUsers,
            limit,
            colorMode
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.250"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
            size: "small"
        }, title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            color: "color.text.subtlest"
        }, description)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center"
        }, dividerLimit !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            appearance: "stack",
            data: avatars,
            maxCount: dividerLimit + 1,
            size: size ?? 'medium',
            overrides: {
                Avatar: {
                    render: (Component, props, index)=>index === dividerLimit - 1 && avatars.length > dividerLimit ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                            ...props,
                            key: index
                        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                            xcss: $0adc97e9cdd80cf0$var$dividerStyles
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5qRwM")).default), {
                            src: (0, ($parcel$interopDefault($2xRzL))),
                            alt: "Simple example",
                            testId: "image"
                        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                            ...props,
                            key: index
                        })
                }
            }
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            appearance: "stack",
            data: avatars,
            maxCount: 11,
            size: size ?? 'medium'
        })));
    };
});
parcelRegister("jSXYd", function(module, exports) {
    module.exports = new URL("user-brand-dark.53b470c6.svg", import.meta.url).toString();
});
parcelRegister("bno7S", function(module, exports) {
    module.exports = new URL("user-brand-light.00eefa28.svg", import.meta.url).toString();
});
parcelRegister("2xRzL", function(module, exports) {
    module.exports = new URL("user-divider.cbebe2f3.svg", import.meta.url).toString();
});
parcelRegister("2hg0p", function(module, exports) {
    module.exports = new URL("user-gray-dark.f2ef58b1.svg", import.meta.url).toString();
});
parcelRegister("dvgRl", function(module, exports) {
    module.exports = new URL("user-gray-light.b6caaf13.svg", import.meta.url).toString();
});
parcelRegister("e4uOc", function(module, exports) {
    module.exports = new URL("user_stars.9007dbd9.svg", import.meta.url).toString();
});
parcelRegister("3IBj4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfebc72c0a4c7346$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bfebc72c0a4c7346$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        jswStandardUserModalTitleUrgent: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title-urgent",
            "defaultMessage": "Don\u2019t lose access to unlimited users"
        },
        jswStandardUserModalSubTitleUrgent: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title-urgent",
            "defaultMessage": "Your Standard trial ends on {trialEndDate}. Add payment or <a>remove users</a> to avoid deactivation."
        },
        jswStandardUserModalRemoveUsersLinkText: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-remove-users-link-text",
            "defaultMessage": "remove users"
        },
        jswStandardUserModalTitle: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title",
            "defaultMessage": "Keep adding your entire team"
        },
        jswStandardUserModalTitleNoPay: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title-no-pay",
            "defaultMessage": "Keep working with your entire team"
        },
        jswStandardUserModalSubTitle: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title",
            "defaultMessage": "Your Standard trial ends on {trialEndDate}. Add payment or <a>remove users</a> to avoid deactivation."
        },
        jswStandardUserModalTitleNoPayUrgent: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title-no-pay-urgent",
            "defaultMessage": "Ask your admin to add payment for Jira Standard. Your trial ends on {trialEndDate}."
        },
        jswStandardUserModalSubTitleNoPayUrgent: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title-no-pay-urgent",
            "defaultMessage": "Ask your admin to add payment for Jira Standard. Your trial ends on {trialEndDate}"
        },
        jswStandardUserModalSubTitleNoPay: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title-no-pay",
            "defaultMessage": "Ask your admin to add payment for Jira Standard, so you can keep unlimited users. Your trial ends on {trialEndDate}."
        },
        jswStandardPrimaryCtaText: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-primary-cta-text",
            "defaultMessage": "Add payment"
        },
        jswStandardPrimaryCtaTextNoPay: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-primary-cta-text-no-pay",
            "defaultMessage": "Close"
        },
        jswStandardSecondaryCtaText: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-secondary-cta-text",
            "defaultMessage": "Maybe later"
        },
        jswStandardUserAvatarTitle: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-avatar-title",
            "defaultMessage": "{userCount} people added"
        },
        jswStandardUserAvatarSubTitle: {
            "id": "loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-avatar-sub-title",
            "defaultMessage": "Your team is over the Free plan\u2019s limit of 10 users"
        }
    });
});
